import React, { useContext, useEffect, useRef, useState } from "react";
import parser from "html-react-parser";
import "./PPMContent.scss";
import { GetcmsContent, MarkDocumentRead, PPM } from "../../utils/Api/api";
import { useNavigate } from "react-router-dom";
import { PageRoutes } from "../../utils/pageRoutes";
import useGeoLocation from "../../components/geoLocation/GeoLoaction";
import { Context } from "../../contextApi/contextProvider";
import { Navbar } from "./deck/Navbar";
import { motion } from "framer-motion";
import { FadeIn, StaggerContainer, StaggerItem } from "./deck/AnimatedSection";
import { SectionLabel } from "./deck/SectionLabel";
import { countries } from "../../pages/Contact/ContactUs";
import {
  ShieldCheck,
  LayoutGrid,
  Cpu,
  Lock,
  Calendar,
  MessageCircle,
  ArrowRight,
  Target,
  Compass,
  Heart,
  CheckCircle2,
  Layers,
  Eye,
  Bot,
  AlertTriangle,
  Clock,
  FileWarning,
  Activity,
  Wallet,
  Shield,
  Brain,
  DollarSign,
  XCircle,
  FileCheck,
  ExternalLink,
  Users,
  Phone,
  Kanban,
  Sparkles,
  Tag,
  GitBranch,
  BarChart3,
  Building2,
  Briefcase,
  Globe2,
  User,
  Landmark,
  Building,
  Globe,
  CheckCircle,
  TrendingUp,
  Zap,
  Database,
  RefreshCw,
  BrainCircuit,
  FolderOpen,
  Crosshair,
  Award,
  MapPin,
  Plane,
  Wrench,
  UserCheck,
  Lightbulb,
  Box,
  Rocket,
  FileText,
} from "lucide-react";
import { DemoRequestModal } from "./deck/DemoRequestModal";
import { LLMProblemSolutionModal } from "./deck/LLMProblemSolutionModal";
import {
  ShimmerLoaderOneLine,
  ShimmerLoaderwhite,
} from "../../utils/loader/ShimmerLoader";

const ExecutiveSummary = () => {
  const loaction = useGeoLocation();
  const [demoOpen, setDemoOpen] = useState(false);
  const navigator = useNavigate();
  const token = JSON.parse(localStorage.getItem("access_token") as string);
  const [htmlString, setHtmlStr] = useState([]);
  const [llmOpen, setLlmOpen] = useState(false);
  const {
    userLoginData,
    setUserLoginData,
    setAccessDoc,
    accessDoc,
    setLoadingLoader,
  } = useContext(Context);

  useEffect(() => {
    if (userLoginData.status == 200 && accessDoc["13678"] !== "de") {
      const fetchData = async (data: PPM, talkbtn: boolean) => {
        try {
          const response1 = await GetcmsContent(data);

          setHtmlStr(response1.data?.content?.split("<!--nextpage-->"));
        } catch (error) {
          console.error("Error fetching data from endpoint1:", error);
        } finally {
          setLoadingLoader(false);
        }
      };
      const getTalk = async (ip: string) => {
        setLoadingLoader(true);
        if (accessDoc["13678"] === "ALLOWED") {
          fetchData(
            {
              post_id: "13678",
              ip_address: ip,
              form_lat: await loaction.coordinates.lat,
              form_lon: await loaction.coordinates.lng,
            },
            true,
          );
        } else {
          navigator("/");
        }
      };

      const fetchIpAddress = async () => {
        try {
          getTalk(userLoginData.ip);
        } catch (error) {}
      };

      fetchIpAddress();
    } else if (userLoginData.status == 404) {
      navigator("/");
    } else if (token === "" || token === null || token === undefined) {
      navigator("/");
    }

    // window.scrollTo(0, 0);
    document.title = "TICCA | Business  Summary";
  }, [userLoginData.status, accessDoc]);

  const readDoc = async () => {
    try {
      const { data } = await MarkDocumentRead({
        ip_address: await userLoginData.ip,
        latitude: loaction.coordinates?.lat ?? "0.0",
        longitude: loaction.coordinates?.lng ?? "0.0",
        post_id: "13678",
      });
    } catch (error) {}
  };
  useEffect(() => {
    if (userLoginData.status == 200) {
      readDoc();
    }
  }, [userLoginData.status]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const painPoints = [
    {
      num: "01",
      icon: <Clock className="w-5 h-5" />,
      title: `${htmlString[65]}`,
      color: "text-ticca-blue",
      border: "border-ticca-blue/20",
      bg: "bg-ticca-blue/[0.04]",
      problems: [`${htmlString[66]}`, `${htmlString[67]}`, `${htmlString[68]}`],
      fixes: [`${htmlString[69]}`, `${htmlString[70]}`, `${htmlString[71]}`],
      result: `${htmlString[72]}`,
    },
    {
      num: "02",
      icon: <FileWarning className="w-5 h-5" />,
      title: `${htmlString[73]}`,
      color: "text-ticca-orange",
      border: "border-ticca-orange/20",
      bg: "bg-ticca-orange/[0.04]",
      problems: [`${htmlString[74]}`, `${htmlString[75]}`, `${htmlString[76]}`],
      fixes: [`${htmlString[77]}`, `${htmlString[78]}`, `${htmlString[79]}`],
      result: `${htmlString[80]}`,
    },
    {
      num: "03",
      icon: <Eye className="w-5 h-5" />,
      title: `${htmlString[81]}`,
      color: "text-ticca-green",
      border: "border-ticca-green/20",
      bg: "bg-ticca-green/[0.04]",
      problems: [`${htmlString[82]}`, `${htmlString[83]}`, `${htmlString[84]}`],
      fixes: [`${htmlString[85]}`, `${htmlString[86]}`, `${htmlString[87]}`],
      result: `${htmlString[88]}`,
    },
    {
      num: "04",
      icon: <Layers className="w-5 h-5" />,
      title: `${htmlString[89]}`,
      color: "text-ticca-blue",
      border: "border-ticca-blue/20",
      bg: "bg-ticca-blue/[0.04]",
      problems: [`${htmlString[90]}`, `${htmlString[91]}`, `${htmlString[92]}`],
      fixes: [`${htmlString[93]}`, `${htmlString[94]}`, `${htmlString[95]}`],
      result: `${htmlString[96]}`,
    },
    {
      num: "05",
      icon: <Activity className="w-5 h-5" />,
      title: `${htmlString[97]}`,
      color: "text-ticca-green",
      border: "border-ticca-green/20",
      bg: "bg-ticca-green/[0.04]",
      problems: [
        `${htmlString[98]}`,
        `${htmlString[99]}`,
        `${htmlString[100]}`,
      ],
      fixes: [`${htmlString[101]}`, `${htmlString[102]}`, `${htmlString[103]}`],
      result: `${htmlString[104]}`,
    },
    {
      num: "06",
      icon: <Bot className="w-5 h-5" />,
      title: `${htmlString[105]}`,
      color: "text-ticca-orange",
      border: "border-ticca-orange/20",
      bg: "bg-ticca-orange/[0.04]",
      problems: [
        `${htmlString[106]}`,
        `${htmlString[107]}`,
        `${htmlString[108]}`,
      ],
      fixes: [`${htmlString[109]}`, `${htmlString[110]}`, `${htmlString[111]}`],
      result: `${htmlString[112]}`,
    },
    {
      num: "07",
      icon: <Wallet className="w-5 h-5" />,
      title: `${htmlString[113]}`,
      color: "text-ticca-green",
      border: "border-ticca-green/20",
      bg: "bg-ticca-green/[0.04]",
      problems: [
        `${htmlString[114]}`,
        `${htmlString[115]}`,
        `${htmlString[116]}`,
      ],
      fixes: [`${htmlString[117]}`, `${htmlString[118]}`, `${htmlString[119]}`],
      result: `${htmlString[120]}`,
    },
    {
      num: "08",
      icon: <Shield className="w-5 h-5" />,
      title: `${htmlString[121]}`,
      color: "text-ticca-blue",
      border: "border-ticca-blue/20",
      bg: "bg-ticca-blue/[0.04]",
      problems: [
        `${htmlString[122]}`,
        `${htmlString[123]}`,
        `${htmlString[124]}`,
      ],
      fixes: [`${htmlString[125]}`, `${htmlString[126]}`, `${htmlString[127]}`],
      result: `${htmlString[128]}`,
    },
    {
      num: "09",
      icon: <Brain className="w-5 h-5 text-muted-foreground" />,
      title: `${htmlString[129]}`,
      color: "text-muted-foreground",
      border: "border-border/40",
      bg: "bg-muted/40",
      problems: [
        `${htmlString[130]}`,
        `${htmlString[131]}`,
        `${htmlString[132]}`,
      ],
      fixes: [`${htmlString[133]}`, `${htmlString[134]}`, `${htmlString[135]}`],
      solutionColor:
        "bg-ticca-orange/[0.04] border border-ticca-orange/15 text-ticca-orange",
      result: `${htmlString[136]}`,
    },
    {
      num: "10",
      icon: <DollarSign className="w-5 h-5" />,
      title: `${htmlString[137]}`,
      color: "text-ticca-orange",
      border: "border-ticca-orange/20",
      bg: "bg-ticca-orange/[0.04]",
      problems: [
        `${htmlString[138]}`,
        `${htmlString[139]}`,
        `${htmlString[140]}`,
      ],
      fixes: [`${htmlString[141]}`, `${htmlString[142]}`, `${htmlString[143]}`],
      result: `${htmlString[144]}`,
    },
  ];
  const coreModules = [
    {
      icon: <Clock className="w-5 h-5" />,
      label: `${htmlString[201]}`,
      color: "text-ticca-red",
      bg: "bg-ticca-red/8",
      border: "border-ticca-red/15",
    },
    {
      icon: <ShieldCheck className="w-5 h-5" />,
      label: `${htmlString[202]}`,
      color: "text-ticca-blue",
      bg: "bg-ticca-blue/8",
      border: "border-ticca-blue/15",
    },
    {
      icon: <LayoutGrid className="w-5 h-5" />,
      label: `${htmlString[203]}`,
      color: "text-ticca-green",
      bg: "bg-ticca-green/8",
      border: "border-ticca-green/15",
    },
    {
      icon: <Users className="w-5 h-5" />,
      label: `${htmlString[204]}`,
      color: "text-ticca-orange",
      bg: "bg-ticca-orange/8",
      border: "border-ticca-orange/15",
    },
  ];

  const comingSoon = [
    {
      icon: <Brain className="w-4 h-4" />,
      label: `${htmlString[205]}`,
      color: "text-ticca-blue",
    },
    {
      icon: <Phone className="w-4 h-4" />,
      label: `${htmlString[206]}`,
      color: "text-ticca-green",
    },
    {
      icon: <Kanban className="w-4 h-4" />,
      label: `${htmlString[207]}`,
      color: "text-ticca-orange",
    },
  ];

  const day1Steps = [
    `${htmlString[212]}`,
    `${htmlString[213]}`,
    `${htmlString[214]}`,
    `${htmlString[215]}`,
    `${htmlString[216]}`,
  ];
  const segments = [
    {
      icon: <User className="w-5 h-5" />,
      label: `${htmlString[241]}`,
      color: "text-ticca-red",
      bg: "bg-ticca-red/8",
    },
    {
      icon: <Building className="w-5 h-5" />,
      label: `${htmlString[242]}`,
      color: "text-ticca-orange",
      bg: "bg-ticca-orange/8",
    },
    {
      icon: <Globe2 className="w-5 h-5" />,
      label: `${htmlString[243]}`,
      color: "text-ticca-green",
      bg: "bg-ticca-green/8",
    },
    {
      icon: <Landmark className="w-5 h-5" />,
      label: `${htmlString[244]}`,
      color: "text-ticca-blue",
      bg: "bg-ticca-blue/8",
    },
    {
      icon: <Building2 className="w-5 h-5" />,
      label: `${htmlString[245]}`,
      color: "text-ticca-red",
      bg: "bg-ticca-red/8",
    },
    {
      icon: <Briefcase className="w-5 h-5" />,
      label: `${htmlString[246]}`,
      color: "text-ticca-orange",
      bg: "bg-ticca-orange/8",
    },
    {
      icon: <Cpu className="w-5 h-5" />,
      label: `${htmlString[247]}`,
      color: "text-ticca-green",
      bg: "bg-ticca-green/8",
    },
    {
      icon: <Shield className="w-5 h-5" />,
      label: `${htmlString[248]}`,
      color: "text-ticca-blue",
      bg: "bg-ticca-blue/8",
    },
  ];

  const requirements = [
    {
      icon: <Globe className="w-5 h-5 text-ticca-red" />,
      title: `${htmlString[263]}`,
      desc: `${htmlString[264]}`,
      bg: "bg-ticca-red/5",
    },
    {
      icon: <Shield className="w-5 h-5 text-ticca-orange" />,
      title: `${htmlString[265]}`,
      desc: `${htmlString[266]}`,
      bg: "bg-ticca-orange/5",
    },
    {
      icon: <FileCheck className="w-5 h-5 text-ticca-green" />,
      title: `${htmlString[267]}`,
      desc: `${htmlString[268]}`,
      bg: "bg-ticca-green/5",
    },
  ];

  const s = [
    {
      icon: <Target className="w-4 h-4 text-ticca-orange" />,
      text: `${htmlString[251]}`,
    },
    {
      icon: <Target className="w-4 h-4 text-ticca-orange" />,
      text: `${htmlString[252]}`,
    },
    {
      icon: <Target className="w-4 h-4 text-ticca-orange" />,
      text: `${htmlString[253]}`,
    },
  ];

  const whyWins = [
    {
      icon: <CheckCircle className="w-4 h-4 text-ticca-green" />,
      text: `${htmlString[255]}`,
    },
    {
      icon: <CheckCircle className="w-4 h-4 text-ticca-green" />,
      text: `${htmlString[256]}`,
    },
    {
      icon: <CheckCircle className="w-4 h-4 text-ticca-green" />,
      text: `${htmlString[257]}`,
    },
  ];

  const expansionTargets = [
    `${htmlString[259]}`,
    `${htmlString[260]}`,
    `${htmlString[261]}`,
  ];
  const advantages = [
    {
      icon: <ShieldCheck className="w-5 h-5 text-ticca-red" />,
      badge: `${htmlString[270]}`,
      badgeBg: "bg-ticca-red/10 text-ticca-red",
      title: `${htmlString[271]}`,
      desc: "First verification layer across workflows, creating an entirely new category",
      highlight:
        "-> Only platform connecting activity -> output -> verification",
      border: "border-ticca-red/20",
      bg: "bg-background",
    },
    {
      icon: <Layers className="w-5 h-5 text-ticca-orange" />,
      badge: `${htmlString[272]}`,
      badgeBg: "bg-ticca-orange/10 text-ticca-orange",
      title: `${htmlString[273]}`,
      desc: "Replaces fragmented stacks with one integrated system",
      highlight: "-> Consolidate 6+ tools into single solution",
      border: "border-ticca-orange/20",
      bg: "bg-background",
    },
    {
      icon: <Lock className="w-5 h-5 text-ticca-green" />,
      badge: `${htmlString[274]}`,
      badgeBg: "bg-ticca-green/10 text-ticca-green",
      title: `${htmlString[275]}`,
      desc: "Multi-layer, policy-driven enforcement at enterprise scale",
      highlight: "-> Advanced CREAD model with clearance-based access",
      border: "border-ticca-green/20",
      bg: "bg-background",
    },
    {
      icon: <Sparkles className="w-5 h-5 text-ticca-blue" />,
      badge: `${htmlString[276]}`,
      badgeBg: "bg-ticca-blue/10 text-ticca-blue",
      title: `${htmlString[277]}`,
      desc: "Traceable, measurable AI contributions embedded in workflows",
      highlight: "AI attribution and verification built-in",
      border: "border-ticca-blue/20",
      bg: "bg-background",
    },
  ];

  const comparisonRows = [
    { feature: `${htmlString[279]}`, traditional: false, ticca: true },
    { feature: `${htmlString[280]}`, traditional: false, ticca: true },
    { feature: `${htmlString[281]}`, traditional: false, ticca: true },
    { feature: `${htmlString[282]}`, traditional: "Basic", ticca: "Advanced" },
    { feature: `${htmlString[283]}`, traditional: false, ticca: true },
  ];
  const shifts = [
    {
      icon: <Bot className="w-5 h-5" />,
      title: `${htmlString[286]}`,
      color: "text-ticca-blue",
      borderColor: "border-ticca-blue/20",
      bgColor: "bg-ticca-blue/[0.04]",
      desc: `${htmlString[287]}`,
      points: [
        `${htmlString[288]}`,
        `${htmlString[289]}`,
        `${htmlString[290]}`,
      ],
      conclusion: `${htmlString[291]}`,
    },
    {
      icon: <Globe className="w-5 h-5" />,
      title: `${htmlString[292]}`,
      color: "text-ticca-orange",
      borderColor: "border-ticca-orange/20",
      bgColor: "bg-ticca-orange/[0.04]",
      desc: `${htmlString[293]}`,
      points: [
        `${htmlString[294]}`,
        `${htmlString[295]}`,
        `${htmlString[296]}`,
      ],
    },
    {
      icon: <Layers className="w-5 h-5" />,
      title: `${htmlString[297]}`,
      color: "text-ticca-red",
      borderColor: "border-ticca-red/20",
      bgColor: "bg-ticca-red/[0.04]",
      desc: `${htmlString[298]}`,
      points: [
        `${htmlString[299]}`,
        `${htmlString[300]}`,
        `${htmlString[301]}`,
      ],
    },
  ];
  const pillars = [
    {
      icon: <Shield className="w-5 h-5" />,
      title: `${htmlString[304]}`,
      color: "text-ticca-blue",
      borderColor: "border-ticca-blue/20",
      bgColor: "bg-ticca-blue/[0.04]",
      content: (
        <>
          {htmlString[304] ? (
            parser(htmlString[305])
          ) : (
            <div className="w-full mt-3 ">
              <ShimmerLoaderOneLine />
            </div>
          )}
          <div className="flex items-center gap-2 flex-wrap mb-3">
            {[
              `${htmlString[306]}`,
              `${htmlString[307]}`,
              `${htmlString[308]}`,
            ].map((step, i) => (
              <span key={i} className="flex items-center gap-2">
                <span className="px-3 py-1.5 rounded-full bg-ticca-blue/8 border border-ticca-blue/15 text-sm font-semibold text-foreground">
                  {!htmlString[306 + i] ? (
                    <div className="w-[80px] mt-3 ">
                      <ShimmerLoaderOneLine />
                    </div>
                  ) : (
                    parser(step)
                  )}
                </span>
                {i < 2 && <ArrowRight className="w-4 h-4 text-ticca-blue" />}
              </span>
            ))}
          </div>
          {htmlString[309] ? (
            parser(htmlString[309])
          ) : (
            <div className="w-full mt-3 ">
              <ShimmerLoaderOneLine />
            </div>
          )}
        </>
      ),
    },
    {
      icon: <Database className="w-5 h-5" />,
      title: `${htmlString[310]}`,
      color: "text-ticca-green",
      borderColor: "border-ticca-green/20",
      bgColor: "bg-ticca-green/[0.04]",
      content: (
        <>
          {htmlString[311] ? (
            parser(htmlString[311])
          ) : (
            <div className="w-full mt-3 ">
              <ShimmerLoaderOneLine />
            </div>
          )}
          <ul className="space-y-2 mb-3">
            {[htmlString[312], htmlString[313], htmlString[314]].map(
              (item, j) => (
                <li
                  key={j}
                  className="flex items-start gap-2 text-sm text-muted-foreground"
                >
                  <ArrowRight className="w-3.5 h-3.5 mt-0.5 shrink-0 text-ticca-green" />
                  {typeof item !== "string" ? (
                    <ShimmerLoaderOneLine />
                  ) : (
                    parser(item)
                  )}
                </li>
              ),
            )}
          </ul>
          {htmlString[315] ? (
            parser(htmlString[315])
          ) : (
            <div className="w-full mt-3 ">
              <ShimmerLoaderOneLine />
            </div>
          )}
        </>
      ),
    },
    {
      icon: <RefreshCw className="w-5 h-5" />,
      title: `${htmlString[316]}`,
      color: "text-ticca-red",
      borderColor: "border-ticca-red/20",
      bgColor: "bg-ticca-red/[0.04]",
      content: (
        <>
          {htmlString[316] ? (
            parser(htmlString[317])
          ) : (
            <div className="w-full mt-3 ">
              <ShimmerLoaderOneLine />
            </div>
          )}
          <ul className="space-y-2 mb-3">
            {[
              htmlString[318],
              htmlString[319],
              htmlString[320],
              htmlString[321],
            ].map((item, j) => (
              <li
                key={j}
                className="flex items-start gap-2 text-sm text-muted-foreground"
              >
                <ArrowRight className="w-3.5 h-3.5 mt-0.5 shrink-0 text-ticca-red" />
                {typeof item !== "string" ? (
                  <ShimmerLoaderOneLine />
                ) : (
                  parser(item)
                )}
              </li>
            ))}
          </ul>
          {htmlString[322] ? (
            parser(htmlString[322])
          ) : (
            <div className="w-full mt-3 ">
              <ShimmerLoaderOneLine />
            </div>
          )}
        </>
      ),
    },
    {
      icon: <Compass className="w-5 h-5" />,
      title: `${htmlString[323]}`,
      color: "text-ticca-orange",
      borderColor: "border-ticca-orange/20",
      bgColor: "bg-ticca-orange/[0.04]",
      content: (
        <>
          {htmlString[324] ? (
            parser(htmlString[324])
          ) : (
            <div className="w-full mt-3 ">
              <ShimmerLoaderOneLine />
            </div>
          )}
          <ul className="space-y-1.5 mb-3">
            {[htmlString[325], htmlString[326]].map((item, j) => (
              <li
                key={j}
                className="flex items-start gap-2 text-sm text-muted-foreground"
              >
                <ArrowRight className="w-3.5 h-3.5 mt-0.5 shrink-0 text-ticca-orange" />
                {typeof item !== "string" ? (
                  <ShimmerLoaderOneLine />
                ) : (
                  parser(item)
                )}
              </li>
            ))}
          </ul>
          {htmlString[327] ? (
            parser(htmlString[327])
          ) : (
            <div className="w-full mt-3 ">
              <ShimmerLoaderOneLine />
            </div>
          )}
          {htmlString[328] ? (
            parser(htmlString[328])
          ) : (
            <div className="w-full mt-3 ">
              <ShimmerLoaderOneLine />
            </div>
          )}
        </>
      ),
    },
  ];
  const datasets = [
    {
      icon: <Activity className="w-4 h-4" />,
      label: "Human productivity",
      color: "text-ticca-blue",
      bg: "bg-ticca-blue/8",
      border: "border-ticca-blue/15",
    },
    {
      icon: <Bot className="w-4 h-4" />,
      label: "AI attribution",
      color: "text-ticca-green",
      bg: "bg-ticca-green/8",
      border: "border-ticca-green/15",
    },
    {
      icon: <BarChart3 className="w-4 h-4" />,
      label: "Workflow behavior",
      color: "text-ticca-orange",
      bg: "bg-ticca-orange/8",
      border: "border-ticca-orange/15",
    },
    {
      icon: <FileCheck className="w-4 h-4" />,
      label: "Output intelligence",
      color: "text-ticca-red",
      bg: "bg-ticca-red/8",
      border: "border-ticca-red/15",
    },
  ];

  const lockInItems = [
    {
      label: `${htmlString[340]}`,
      color: "border-ticca-blue/20 bg-ticca-blue/[0.04]",
    },
    {
      label: `${htmlString[341]}`,
      color: "border-ticca-green/20 bg-ticca-green/[0.04]",
    },
    {
      label: `${htmlString[342]}`,
      color: "border-ticca-orange/20 bg-ticca-orange/[0.04]",
    },
    {
      label: `${htmlString[343]}`,
      color: "border-ticca-red/20 bg-ticca-red/[0.04]",
    },
  ];

  const whySegments = [
    {
      icon: <Target className="w-4 h-4 text-ticca-orange" />,
      text: `${htmlString[348]}`,
    },
    {
      icon: <Target className="w-4 h-4 text-ticca-orange" />,
      text: `${htmlString[349]}`,
    },
    {
      icon: <Target className="w-4 h-4 text-ticca-orange" />,
      text: `${htmlString[350]}`,
    },
  ];

  const whyWinss = [
    {
      icon: <CheckCircle className="w-4 h-4 text-ticca-green" />,
      text: "Connects work directly to proof",
    },
    {
      icon: <CheckCircle className="w-4 h-4 text-ticca-green" />,
      text: "Eliminates disputes and manual reporting",
    },
    {
      icon: <CheckCircle className="w-4 h-4 text-ticca-green" />,
      text: "Provides verifiable output for clients",
    },
  ];
  const tiers = [
    {
      name: "Essential",
      sub: "Basic",
      color: "bg-muted-foreground/60",
      textColor: "text-white",
    },
    {
      name: "Bronze",
      sub: "$",
      color: "bg-ticca-orange/70",
      textColor: "text-white",
    },
    {
      name: "Silver",
      sub: "$$",
      color: "bg-muted-foreground/40",
      textColor: "text-foreground",
    },
    {
      name: "Gold",
      sub: "$$$",
      color: "bg-yellow-400",
      textColor: "text-foreground",
    },
    {
      name: "Platinum",
      sub: "$$$$",
      color: "bg-muted-foreground/30",
      textColor: "text-foreground",
    },
  ];

  const revenueStreams = [
    {
      icon: <Users className="w-5 h-5 text-ticca-blue" />,
      title: `${htmlString[377]}`,
      desc: `${htmlString[378]}`,
      detail: `${htmlString[379]}`,
      border: "border-ticca-blue/20",
      bg: "bg-ticca-blue/[0.03]",
    },
    {
      icon: <Zap className="w-5 h-5 text-ticca-orange" />,
      title: `${htmlString[380]}`,
      desc: `${htmlString[381]}`,
      detail: `${htmlString[382]}`,
      border: "border-ticca-orange/20",
      bg: "bg-ticca-orange/[0.03]",
    },
    {
      icon: <Building2 className="w-5 h-5 text-ticca-green" />,
      title: `${htmlString[383]}`,
      desc: `${htmlString[384]}`,
      detail: `${htmlString[385]}`,
      border: "border-ticca-green/20",
      bg: "bg-ticca-green/[0.03]",
    },
  ];
  const stats = [
    {
      icon: <Users className="w-5 h-5 text-ticca-blue" />,
      value: "12",
      label: "Team Members",
      sub: "Internal usage",
    },
    {
      icon: <Clock className="w-5 h-5 text-ticca-green" />,
      value: "~50K",
      label: "Hours/Year",
      sub: "Tracked annually",
    },
    {
      icon: <Activity className="w-5 h-5 text-ticca-orange" />,
      value: "~200K",
      label: "Total Hours",
      sub: "Over 4 years",
    },
    {
      icon: <FolderOpen className="w-5 h-5 text-ticca-red" />,
      value: "120+",
      label: "Projects",
      sub: "Over 10 years",
    },
  ];
  const milestones = [
    {
      year: `${htmlString[412]}`,
      label: `${htmlString[413]}`,
      icon: <Globe className="w-3.5 h-3.5" />,
    },
    {
      year: `${htmlString[414]}`,
      label: `${htmlString[415]}`,
      icon: <MapPin className="w-3.5 h-3.5" />,
    },
    {
      year: `${htmlString[416]}`,
      label: `${htmlString[417]}`,
      icon: <Award className="w-3.5 h-3.5" />,
    },
    {
      year: `${htmlString[418]}`,
      label: `${htmlString[419]}`,
      icon: <Bot className="w-3.5 h-3.5" />,
    },
  ];
  const experiences = [
    {
      icon: <Wrench className="w-4 h-4" />,
      text: `${htmlString[425]}`,
      color: "text-ticca-red",
    },
    {
      icon: <Eye className="w-4 h-4" />,
      text: `${htmlString[426]}`,
      color: "text-ticca-orange",
    },
    {
      icon: <AlertTriangle className="w-4 h-4" />,
      text: `${htmlString[427]}`,
      color: "text-ticca-blue",
    },
  ];

  const expansions = [
    {
      icon: <Building2 className="w-4 h-4" />,
      label: "Enterprise",
      color: "bg-ticca-blue/8 border-ticca-blue/15 text-ticca-blue",
    },
    {
      icon: <Bot className="w-4 h-4" />,
      label: "AI-first organizations",
      color: "bg-ticca-green/8 border-ticca-green/15 text-ticca-green",
    },
    {
      icon: <ShieldCheck className="w-4 h-4" />,
      label: "Compliance-heavy sectors",
      color: "bg-ticca-orange/8 border-ticca-orange/15 text-ticca-orange",
    },
  ];

  return (
    <>
      <div className="min-h-screen bg-background">
        <Navbar />
        <section className="relative min-h-[92vh] flex items-center overflow-hidden pt-[6.5rem]">
          <div className="absolute inset-0 bg-dot-pattern opacity-20" />
          <div className="absolute top-20 right-10 w-[500px] h-[500px] bg-ticca-blue/4 rounded-full blur-[120px]" />
          <div className="absolute bottom-20 left-10 w-[400px] h-[400px] bg-ticca-red/3 rounded-full blur-[100px]" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-ticca-green/3 rounded-full blur-[150px]" />

          <div className="container relative z-10">
            {/* Main Hero */}
            <div className="text-center max-w-3xl mx-auto mb-12">
              <FadeIn>
                <motion.div
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5 }}
                  className=" max-w-3xl mx-auto inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-ticca-blue/8 border border-ticca-blue/15 text-sm font-medium text-ticca-blue mb-6"
                >
                  <ShieldCheck className="w-4 h-4" />
                  {htmlString[23] ? (
                    parser(htmlString[25])
                  ) : (
                    <ShimmerLoaderOneLine />
                  )}
                </motion.div>
              </FadeIn>

              <FadeIn delay={0.08}>
                {htmlString[21] ? (
                  <h1 style={{ fontSize: "48px" }}>{parser(htmlString[22])}</h1>
                ) : (
                  <div className="m-auto flex justify-center">
                    <ShimmerLoaderwhite />
                  </div>
                )}
                {htmlString[22] ? (
                  parser(htmlString[23])
                ) : (
                  <div className="m-auto flex justify-center">
                    <ShimmerLoaderOneLine />
                  </div>
                )}
              </FadeIn>

              <FadeIn delay={0.15}>
                {htmlString[23] ? (
                  parser(htmlString[24])
                ) : (
                  <div className="m-auto flex justify-center">
                    <ShimmerLoaderwhite />
                  </div>
                )}
              </FadeIn>

              {htmlString[23] && (
                <FadeIn delay={0.2}>
                  <div className="flex flex-wrap items-center justify-center gap-3 mb-10">
                    <motion.button
                      onClick={() => setDemoOpen(true)}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.97 }}
                      className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-ticca-blue text-white font-semibold text-sm shadow-brand hover:bg-ticca-blue/90 transition-colors"
                    >
                      <Calendar className="w-4 h-4" />
                      Request a Demo
                    </motion.button>
                    <motion.button
                      onClick={() => {
                        navigator(PageRoutes.question);
                      }}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.97 }}
                      className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-background border-2 border-ticca-blue/30 text-ticca-blue font-semibold text-sm hover:bg-ticca-blue/5 transition-colors"
                    >
                      <MessageCircle className="w-4 h-4" />
                      Talk to our CEO
                    </motion.button>
                  </div>
                </FadeIn>
              )}
            </div>

            {/* Key pillars */}
            <FadeIn delay={0.25}>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-3xl mx-auto mb-10">
                {[
                  {
                    icon: <ShieldCheck className="w-5 h-5" />,
                    label: `${htmlString[26]}`,
                    desc: `${htmlString[27]}`,
                    color: "text-ticca-red",
                    bg: "bg-ticca-red/8",
                    border: "border-ticca-red/15",
                  },
                  {
                    icon: <LayoutGrid className="w-5 h-5" />,
                    label: `${htmlString[28]}`,
                    desc: `${htmlString[29]}`,
                    color: "text-ticca-blue",
                    bg: "bg-ticca-blue/8",
                    border: "border-ticca-blue/15",
                  },
                  {
                    icon: <Cpu className="w-5 h-5" />,
                    label: `${htmlString[30]}`,
                    desc: `${htmlString[31]}`,
                    color: "text-ticca-green",
                    bg: "bg-ticca-green/8",
                    border: "border-ticca-green/15",
                  },
                  {
                    icon: <Lock className="w-5 h-5" />,
                    label: `${htmlString[34]}`,
                    desc: `${htmlString[33]}`,
                    color: "text-ticca-orange",
                    bg: "bg-ticca-orange/8",
                    border: "border-ticca-orange/15",
                  },
                ].map((tag, index) => (
                  <motion.div
                    key={`${tag.label}-${index}-asaa`}
                    whileHover={{ y: -3, scale: 1.02 }}
                    className={`p-4 rounded-xl ${tag.bg} border ${tag.border} text-center cursor-default`}
                  >
                    <div className={`${tag.color} flex justify-center mb-2`}>
                      {tag.icon}
                    </div>
                    <div className="text-sm font-semibold text-foreground">
                      {tag.label === "undefined" ? (
                        <ShimmerLoaderOneLine />
                      ) : (
                        parser(tag.label)
                      )}
                    </div>
                    <div className="text-xs text-muted-foreground mt-0.5">
                      {tag.desc === "undefined" ? (
                        <ShimmerLoaderOneLine />
                      ) : (
                        parser(tag.desc)
                      )}
                    </div>
                  </motion.div>
                ))}
              </div>
            </FadeIn>

            {/* Business summary + Strategic Framing side by side */}
            <FadeIn delay={0.3}>
              <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-4">
                {/* Business summary */}
                <div className="p-5 rounded-2xl bg-secondary/40 border border-border/50">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-2 h-2 rounded-full bg-ticca-blue" />
                    {htmlString[33] ? (
                      parser(htmlString[34])
                    ) : (
                      <ShimmerLoaderOneLine />
                    )}
                  </div>
                  {htmlString[34] ? (
                    parser(htmlString[35])
                  ) : (
                    <ShimmerLoaderwhite />
                  )}
                </div>

                {/* Strategic Framing */}
                <div className="p-5 rounded-2xl bg-ticca-blue/[0.04] border border-ticca-blue/15 flex flex-col">
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-2 h-2 rounded-full bg-ticca-green" />
                    {htmlString[35] ? (
                      parser(htmlString[36])
                    ) : (
                      <ShimmerLoaderOneLine />
                    )}
                  </div>
                  {htmlString[36] ? (
                    parser(htmlString[37])
                  ) : (
                    <ShimmerLoaderOneLine />
                  )}
                  {htmlString[36] ? (
                    parser(htmlString[38])
                  ) : (
                    <ShimmerLoaderOneLine />
                  )}
                  <div className="mt-auto p-3.5 rounded-xl bg-background/60 border border-border/30">
                    <div className="flex items-start gap-2">
                      <ArrowRight className="w-3.5 h-3.5 text-ticca-blue mt-0.5 shrink-0" />
                      {htmlString[36] ? (
                        parser(htmlString[39])
                      ) : (
                        <ShimmerLoaderOneLine />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>

          <DemoRequestModal
            open={demoOpen}
            onClose={() => setDemoOpen(false)}
          />
        </section>
        <section id="vision" className="py-16 relative">
          <div className="absolute inset-0 bg-grid-pattern opacity-15" />
          <div className="container relative">
            <FadeIn>
              <SectionLabel label="Vision · Mission · Passion" color="blue" />
              {htmlString[40] ? (
                parser(htmlString[40])
              ) : (
                <div className="mt-5 mb-5">
                  <ShimmerLoaderOneLine />
                </div>
              )}
            </FadeIn>

            <div className="grid md:grid-cols-3 gap-4">
              {/* Vision */}
              <FadeIn delay={0.05}>
                <motion.div
                  whileHover={{ y: -3 }}
                  className="p-5 rounded-xl bg-secondary/40 border border-border/50 h-full"
                >
                  <div className="flex items-center gap-2.5 mb-3">
                    <div className="w-9 h-9 rounded-lg bg-ticca-blue/10 flex items-center justify-center">
                      <Target className="w-4.5 h-4.5 text-ticca-blue" />
                    </div>
                    {htmlString[40] ? (
                      parser(htmlString[41])
                    ) : (
                      <ShimmerLoaderOneLine />
                    )}
                  </div>
                  {htmlString[41] ? (
                    parser(htmlString[42])
                  ) : (
                    <ShimmerLoaderwhite />
                  )}
                </motion.div>
              </FadeIn>

              {/* Mission */}
              <FadeIn delay={0.1}>
                <motion.div
                  whileHover={{ y: -3 }}
                  className="p-5 rounded-xl bg-secondary/40 border border-border/50 h-full"
                >
                  <div className="flex items-center gap-2.5 mb-3">
                    <div className="w-9 h-9 rounded-lg bg-ticca-blue/10 flex items-center justify-center">
                      <Compass className="w-4.5 h-4.5 text-ticca-green" />
                    </div>
                    {htmlString[40] ? (
                      parser(htmlString[43])
                    ) : (
                      <ShimmerLoaderOneLine />
                    )}
                  </div>
                  {htmlString[43] ? (
                    parser(htmlString[44])
                  ) : (
                    <ShimmerLoaderwhite />
                  )}
                  <div className="flex flex-wrap gap-1.5"></div>
                </motion.div>
              </FadeIn>

              {/* Passion */}
              <FadeIn delay={0.15}>
                <motion.div
                  whileHover={{ y: -3 }}
                  className="p-5 rounded-xl bg-secondary/40 border border-border/50 h-full"
                >
                  <div className="flex items-center gap-2.5 mb-3">
                    <div className="w-9 h-9 rounded-lg bg-ticca-blue/10 flex items-center justify-center">
                      <Heart className="w-4.5 h-4.5 text-ticca-red" />
                    </div>
                    {htmlString[40] ? (
                      parser(htmlString[45])
                    ) : (
                      <ShimmerLoaderOneLine />
                    )}
                  </div>
                  {htmlString[43] ? (
                    parser(htmlString[46])
                  ) : (
                    <ShimmerLoaderwhite />
                  )}
                  <div className="flex flex-wrap gap-1.5"></div>
                </motion.div>
              </FadeIn>
            </div>
          </div>
        </section>
        <section id="problem" className="py-16 relative">
          <div className="absolute inset-0">
            <div className="absolute top-1/2 left-0 w-[250px] h-[250px] bg-ticca-red/3 rounded-full blur-[80px]" />
          </div>
          <div className="container relative">
            <FadeIn>
              <SectionLabel label="The Problem" color="red" />
              {htmlString[47] ? (
                parser(htmlString[47])
              ) : (
                <div className="mt-5 mb-5">
                  <ShimmerLoaderOneLine />
                  <ShimmerLoaderOneLine />
                </div>
              )}
            </FadeIn>

            <StaggerContainer className="grid md:grid-cols-3 gap-4">
              {[
                {
                  icon: <Layers className="w-5 h-5" />,
                  num: "01",
                  title: `${htmlString[48]}`,
                  color: "text-ticca-red",
                  bgColor: "bg-ticca-red/[0.04]",
                  borderColor: "border-ticca-red/20",
                  points: [
                    `${htmlString[49]}`,
                    `${htmlString[50]}`,
                    `${htmlString[51]}`,
                    `${htmlString[52]}`,
                  ],
                },
                {
                  icon: <Eye className="w-5 h-5" />,
                  num: "02",
                  title: `${htmlString[53]}`,
                  color: "text-ticca-orange",
                  bgColor: "bg-ticca-orange/[0.04]",
                  borderColor: "border-ticca-orange/20",
                  points: [
                    `${htmlString[54]}`,
                    `${htmlString[55]}`,
                    `${htmlString[56]}`,
                    `${htmlString[57]}`,
                  ],
                },
                {
                  icon: <Bot className="w-5 h-5" />,
                  num: "03",
                  title: `${htmlString[58]}`,
                  color: "text-ticca-blue",
                  bgColor: "bg-ticca-blue/[0.04]",
                  borderColor: "border-ticca-blue/20",
                  points: [
                    `${htmlString[59]}`,
                    `${htmlString[60]}`,
                    `${htmlString[61]}`,
                    `${htmlString[62]}`,
                  ],
                },
              ].map((problem) => (
                <StaggerItem key={problem.num}>
                  <motion.div
                    whileHover={{ y: -3, scale: 1.01 }}
                    className={`p-5 rounded-xl border ${problem.borderColor} ${problem.bgColor} h-full`}
                  >
                    <div className="flex items-center gap-2 mb-3">
                      <span
                        className={`font-display font-bold text-2xl ${problem.color} opacity-25`}
                      >
                        {problem.num}
                      </span>
                      <span className={problem.color}>{problem.icon}</span>
                    </div>
                    <h3 className="font-display font-bold text-base mb-2.5 text-foreground">
                      {problem.title === "undefined" ? (
                        <span>
                          <ShimmerLoaderOneLine />
                        </span>
                      ) : (
                        parser(problem.title)
                      )}
                    </h3>
                    <ul className="space-y-1.5">
                      {problem.points.map((point, j) => (
                        <li
                          key={j}
                          className="flex items-start gap-2 text-sm text-muted-foreground"
                        >
                          <ArrowRight
                            className={`w-3.5 h-3.5 mt-0.5 shrink-0 ${problem.color}`}
                          />
                          {point === "undefined" ? (
                            <div className="w-full">
                              <ShimmerLoaderOneLine />
                            </div>
                          ) : (
                            parser(point)
                          )}
                        </li>
                      ))}
                    </ul>
                  </motion.div>
                </StaggerItem>
              ))}
            </StaggerContainer>

            {/* Critical gap diagram */}
            <FadeIn delay={0.2}>
              <div className="mt-5 p-4 rounded-xl bg-ticca-red/[0.03] border border-ticca-red/15">
                <div className="flex items-center gap-2 mb-2">
                  <AlertTriangle className="w-4 h-4 text-ticca-red" />
                  <span className="text-sm font-bold text-foreground">
                    As AI adoption grows, verification becomes critical
                    infrastructure, not optional.
                  </span>
                </div>
                <div className="flex items-center gap-3 text-sm font-medium text-foreground">
                  <span className="px-3 py-1.5 rounded-full bg-ticca-red/8 border border-ticca-red/15">
                    Activity
                  </span>
                  <span className="text-ticca-red font-bold">-&gt;</span>
                  <span className="px-3 py-1.5 rounded-full bg-ticca-orange/8 border border-ticca-orange/15">
                    Output
                  </span>
                  <span className="text-ticca-red font-bold">-&gt;</span>
                  <span className="px-3 py-1.5 rounded-full bg-muted/60 border border-border line-through text-muted-foreground">
                    Verification (missing)
                  </span>
                  <span className="text-xs text-ticca-red font-semibold ml-1">
                    Missing today
                  </span>
                </div>
              </div>
            </FadeIn>
          </div>
        </section>
        <section id="pain-points" className="py-16 relative">
          <div className="absolute inset-0">
            <div className="absolute top-1/4 left-0 w-[300px] h-[300px] bg-ticca-red/3 rounded-full blur-[100px]" />
            <div className="absolute bottom-1/4 right-0 w-[250px] h-[250px] bg-ticca-orange/3 rounded-full blur-[100px]" />
          </div>
          <div className="container relative">
            <FadeIn>
              <SectionLabel label="Pain Points" color="red" />
              <div className="flex items-center gap-3 mt-3 mb-2">
                <Target className="w-8 h-8 text-ticca-blue" />
                {htmlString[63] ? (
                  parser(htmlString[63])
                ) : (
                  <div className="w-48">
                    <ShimmerLoaderOneLine />
                  </div>
                )}
              </div>
              {htmlString[64] ? (
                parser(htmlString[64])
              ) : (
                <div className="w-full">
                  <ShimmerLoaderOneLine />
                </div>
              )}
            </FadeIn>
            <StaggerContainer className="grid md:grid-cols-2 gap-5">
              {painPoints.map((pp) => (
                <StaggerItem key={pp.num}>
                  <motion.div
                    whileHover={{ y: -3, scale: 1.005 }}
                    className={`p-5 rounded-xl border ${pp.border} ${pp.bg} h-full`}
                  >
                    {/* Header */}
                    <div className="flex items-center gap-3 mb-4">
                      <span
                        className={`font-display font-bold text-2xl ${pp.color} opacity-25`}
                      >
                        {pp.num}
                      </span>
                      <span className={pp.color}>{pp.icon}</span>
                      <h3 className="font-display font-bold text-base text-foreground">
                        {pp.title == "undefined" ? (
                          <div className="w-48">
                            <ShimmerLoaderOneLine />
                          </div>
                        ) : (
                          parser(pp.title)
                        )}
                      </h3>
                    </div>

                    <div className="grid sm:grid-cols-2 gap-3">
                      {/* Problem */}
                      <div className="p-3 rounded-lg bg-background/60 border border-border/40">
                        <p className="text-xs font-bold text-foreground/60 uppercase tracking-wider mb-2">
                          Problem
                        </p>
                        <ul className="space-y-1.5">
                          {pp.problems.map((p, i) => (
                            <li
                              key={i}
                              className="flex items-start gap-2 text-sm text-muted-foreground"
                            >
                              <AlertTriangle className="w-3 h-3 mt-1 shrink-0 text-ticca-blue/60" />
                              {p === "undefined" ? (
                                <div className="w-full">
                                  <ShimmerLoaderOneLine />
                                </div>
                              ) : (
                                parser(p)
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Solution */}
                      <div
                        className={`p-3 rounded-lg ${pp.solutionColor || "bg-ticca-blue/[0.04] border border-ticca-blue/15"} `}
                      >
                        <p className="text-xs font-bold text-ticca-blue uppercase tracking-wider mb-2">
                          Solution
                        </p>
                        <ul className="space-y-1.5">
                          {pp.fixes.map((f, i) => (
                            <li
                              key={i}
                              className="flex items-start gap-2 text-sm text-foreground/70"
                            >
                              <CheckCircle2 className="w-3 h-3 mt-1 shrink-0 text-ticca-blue" />
                              {f === "undefined" ? (
                                <div className="w-full">
                                  <ShimmerLoaderOneLine />
                                </div>
                              ) : (
                                parser(f)
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {/* Result */}
                    <div className="mt-3 p-2.5 rounded-lg bg-secondary/40 border border-border/30">
                      <p className="text-sm text-foreground/80 font-medium flex items-start gap-2">
                        <ArrowRight className="w-4 h-4 mt-0.5 shrink-0 text-ticca-green" />
                        {pp.result === "undefined" ? (
                          <div className="w-full">
                            <ShimmerLoaderOneLine />
                          </div>
                        ) : (
                          <span className="inline-flex">
                            Result:{" "}
                            {<samp className="pl-1">{parser(pp.result)}</samp>}
                          </span>
                        )}
                      </p>
                    </div>
                  </motion.div>
                </StaggerItem>
              ))}
            </StaggerContainer>

            {/* Core Pain Summary */}
            <FadeIn delay={0.2}>
              <div className="mt-8 p-5 rounded-xl bg-secondary/30 border border-border/50">
                {htmlString[141] ? (
                  parser(htmlString[145])
                ) : (
                  <div className="m-auto flex flex-col gap-2 items-center">
                    <ShimmerLoaderOneLine />
                    <ShimmerLoaderOneLine />
                    <ShimmerLoaderOneLine />
                  </div>
                )}
              </div>
            </FadeIn>

            {/* Investor Framing */}
            <FadeIn delay={0.3}>
              <div className="mt-5 p-4 rounded-xl bg-ticca-orange/[0.03] border border-ticca-orange/15">
                {htmlString[146] ? (
                  parser(htmlString[146])
                ) : (
                  <div className="m-auto flex  w-full justify-center">
                    <ShimmerLoaderOneLine />
                  </div>
                )}
              </div>
            </FadeIn>
          </div>
        </section>
        <section id="solution" className="py-16 relative">
          <div className="absolute inset-0 bg-dot-pattern opacity-15" />
          <div className="container relative">
            <FadeIn>
              <SectionLabel label="The Solution" color="green" />
              {htmlString[147] ? (
                parser(htmlString[147])
              ) : (
                <div className="mt-5 mb-5">
                  <ShimmerLoaderOneLine />
                  <ShimmerLoaderOneLine />
                </div>
              )}
            </FadeIn>

            {/* Competitor Gap */}
            <FadeIn delay={0.05}>
              <div className="mb-5 p-5 rounded-xl bg-secondary/30 border border-border/50 relative overflow-hidden">
                <div className="absolute top-0 right-0 px-3 py-1 bg-muted-foreground/60 text-white text-xs font-bold uppercase tracking-wider rounded-bl-lg">
                  Competitor Gap
                </div>
                {htmlString[148] ? (
                  parser(htmlString[148])
                ) : (
                  <div className="mt-5 mb-5">
                    <ShimmerLoaderOneLine />
                    <ShimmerLoaderOneLine />
                  </div>
                )}
                <div className="grid grid-cols-3 gap-x-6 mb-4 max-w-md">
                  <span className="text-xs font-bold text-muted-foreground uppercase tracking-wider pb-1.5 border-b border-border/40">
                    Tool
                  </span>
                  <span className="text-xs font-bold text-muted-foreground uppercase tracking-wider pb-1.5 border-b border-border/40">
                    Tracks
                  </span>
                  <span className="text-xs font-bold text-muted-foreground uppercase tracking-wider pb-1.5 border-b border-border/40">
                    Verifies?
                  </span>
                  {[
                    ["Asana", "tasks"],
                    ["Hubstaff", "time"],
                    ["Slack", "communication"],
                    ["Google Docs", "documents"],
                  ].map(([tool, tracks]) => (
                    <React.Fragment key={tool}>
                      <span className="text-sm text-muted-foreground py-1.5 border-b border-border/30">
                        {tool}
                      </span>
                      <span className="text-sm text-muted-foreground py-1.5 border-b border-border/30">
                        {tracks}
                      </span>
                      <span className="py-1.5 border-b border-border/30">
                        <XCircle className="w-4 h-4 text-muted-foreground/40" />
                      </span>
                    </React.Fragment>
                  ))}
                </div>
                {htmlString[149] ? (
                  parser(htmlString[149])
                ) : (
                  <ShimmerLoaderOneLine />
                )}
                {htmlString[149] && (
                  <motion.p
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.3, duration: 0.4 }}
                    className="text-lg font-extrabold text-ticca-blue tracking-wide"
                  >
                    and we did it.
                  </motion.p>
                )}
              </div>
            </FadeIn>

            {/* Work Evidence System */}
            <FadeIn delay={0.08}>
              <div className="mb-5 p-5 rounded-xl bg-secondary/30 border border-border/50">
                {htmlString[150] ? (
                  parser(htmlString[150])
                ) : (
                  <div className="mt-5 mb-5">
                    <ShimmerLoaderOneLine />
                    <ShimmerLoaderOneLine />
                  </div>
                )}
                <div className="grid sm:grid-cols-3 gap-3 mb-4">
                  {[
                    `${htmlString[151]}`,
                    `${htmlString[152]}`,
                    `${htmlString[153]}`,
                  ].map((item, i) => (
                    <div
                      key={`work-evidence-item-${i}-${item}`}
                      className="flex items-start gap-2 text-sm text-foreground/80 p-3 rounded-lg bg-background border border-border/40"
                    >
                      <CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0 text-ticca-green" />
                      <span>
                        {item === "undefined" ? (
                          <div className="w-[200px]">
                            <ShimmerLoaderOneLine />
                          </div>
                        ) : (
                          parser(item)
                        )}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Highlighted step flow */}
                <div className="flex flex-wrap items-center justify-center gap-4 mb-4">
                  {[
                    {
                      label: "Activity",
                      color:
                        "bg-ticca-blue/10 border-ticca-blue/30 text-ticca-blue",
                    },
                    {
                      label: "Output",
                      color:
                        "bg-ticca-orange/10 border-ticca-orange/30 text-ticca-orange",
                    },
                    {
                      label: "Verification",
                      color:
                        "bg-ticca-green/10 border-ticca-green/30 text-ticca-green",
                    },
                  ].map((step, i) => (
                    <React.Fragment key={step.label}>
                      <motion.span
                        whileHover={{ scale: 1.08, y: -3 }}
                        className={`px-5 py-2.5 rounded-xl border-2 font-bold text-sm ${step.color} shadow-sm cursor-default`}
                      >
                        {htmlString[154] === "undefined" ? (
                          <span className="w-[150px]">
                            <ShimmerLoaderOneLine />
                          </span>
                        ) : (
                          step.label
                        )}
                      </motion.span>
                      {i < 2 && (
                        <motion.span
                          animate={{ x: [0, 6, 0] }}
                          transition={{
                            duration: 1.5,
                            repeat: Infinity,
                            delay: i * 0.2,
                          }}
                        >
                          <ArrowRight className="w-5 h-5 text-muted-foreground" />
                        </motion.span>
                      )}
                    </React.Fragment>
                  ))}
                </div>

                <div className="p-3 rounded-lg bg-ticca-green/5 border border-ticca-green/10">
                  {htmlString[154] ? (
                    parser(htmlString[154])
                  ) : (
                    <ShimmerLoaderOneLine />
                  )}
                </div>
              </div>
            </FadeIn>

            {/* Four layers */}
            <StaggerContainer className="grid md:grid-cols-2 gap-4">
              {[
                {
                  icon: <ShieldCheck className="w-5 h-5 text-ticca-red" />,
                  num: "1",
                  title: `${htmlString[155]}`,
                  accent: "border-l-ticca-red",
                  description: `${htmlString[156]}`,
                  items: [
                    `${htmlString[157]}`,
                    `${htmlString[158]}`,
                    `${htmlString[159]}`,
                  ],
                },
                {
                  icon: <LayoutGrid className="w-5 h-5 text-ticca-blue" />,
                  num: "2",
                  title: `${htmlString[160]}`,
                  accent: "border-l-ticca-blue",
                  description: `${htmlString[161]}`,
                  items: [
                    `${htmlString[162]}`,
                    `${htmlString[163]}`,
                    `${htmlString[164]}`,
                    `${htmlString[165]}`,
                    `${htmlString[166]}`,
                    `${htmlString[167]}`,
                  ],
                },
                {
                  icon: <Lock className="w-5 h-5 text-ticca-orange" />,
                  num: "3",
                  title: `${htmlString[168]}`,
                  accent: "border-l-ticca-orange",
                  description: `${htmlString[169]}`,
                  items: [
                    `${htmlString[170]}`,
                    `${htmlString[171]}`,
                    `${htmlString[172]}`,
                    `${htmlString[173]}`,
                  ],
                },
                {
                  icon: <Cpu className="w-5 h-5 text-ticca-green" />,
                  num: "4",
                  title: `${htmlString[174]}`,
                  accent: "border-l-ticca-green",
                  description: `${htmlString[175]}`,
                  items: [`${htmlString[176]}`],
                },
              ].map((layer) => (
                <StaggerItem key={layer.num}>
                  <motion.div
                    whileHover={{ y: -3 }}
                    className={`p-5 rounded-xl bg-secondary/30 border border-border/50 border-l-[3px] ${layer.accent} h-full`}
                  >
                    <div className="flex items-center gap-2.5 mb-2">
                      <div className="w-8 h-8 rounded-lg bg-background flex items-center justify-center shadow-card">
                        {layer.icon}
                      </div>
                      <h3 className="flex gap-1  font-display font-bold text-base text-foreground ">
                        <span className="text-muted-foreground mr-1">
                          0{layer.num}.
                        </span>
                        {layer.title === "undefined" ? (
                          <span className="w-full">
                            <ShimmerLoaderOneLine />
                          </span>
                        ) : (
                          parser(layer.title)
                        )}
                      </h3>
                    </div>
                    <p className="text-sm text-muted-foreground mb-2 leading-relaxed">
                      {layer.description === "undefined" ? (
                        <span className="w-full">
                          <ShimmerLoaderOneLine />
                        </span>
                      ) : (
                        parser(layer.description)
                      )}
                    </p>
                    <div className="space-y-1">
                      {layer.items.map((item, j) => (
                        <div
                          key={j}
                          className="flex items-start gap-2 text-sm text-foreground/80"
                        >
                          <CheckCircle2 className="w-3.5 h-3.5 mt-0.5 shrink-0 text-ticca-green" />
                          {item === "undefined" ? (
                            <span className="w-full">
                              <ShimmerLoaderOneLine />
                            </span>
                          ) : (
                            parser(item)
                          )}
                        </div>
                      ))}
                    </div>
                  </motion.div>
                </StaggerItem>
              ))}
            </StaggerContainer>

            {/* Core Breakthrough Feature - matching reference image */}
            <FadeIn delay={0.12}>
              <div className="mt-6 text-center">
                <SectionLabel label="Breakthrough Innovation" color="red" />
                {htmlString[177] ? (
                  parser(htmlString[177])
                ) : (
                  <div className="flex flex-col items-center justify-center mt-5 mb-5">
                    <ShimmerLoaderOneLine />
                    <ShimmerLoaderOneLine />
                  </div>
                )}
              </div>
              <div className="p-6 rounded-2xl bg-gradient-to-br from-secondary/20 via-background to-ticca-blue/[0.02] border border-border/40">
                {/* Reference-image style: 4 cards with arrows */}
                <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-0">
                  {[
                    {
                      icon: <Clock className="w-7 h-7" />,
                      title: `${htmlString[178]}`,
                      desc: `${htmlString[179]}`,
                      borderColor: "border-ticca-red/30",
                      iconBg: "bg-ticca-red/10",
                      iconColor: "text-ticca-red",
                      dark: false,
                    },
                    {
                      icon: <Activity className="w-7 h-7" />,
                      title: `${htmlString[180]}`,
                      desc: `${htmlString[181]}`,
                      borderColor: "border-ticca-orange/30",
                      iconBg: "bg-ticca-orange/10",
                      iconColor: "text-ticca-orange",
                      dark: false,
                    },
                    {
                      icon: <FileCheck className="w-7 h-7" />,
                      title: `${htmlString[182]}`,
                      desc: `${htmlString[183]}`,
                      borderColor: "border-ticca-green/30",
                      iconBg: "bg-ticca-green/10",
                      iconColor: "text-ticca-green",
                      dark: false,
                    },
                    {
                      icon: <ShieldCheck className="w-7 h-7" />,
                      title: `${htmlString[184]}`,
                      desc: `${htmlString[185]}`,
                      borderColor: "border-foreground/20",
                      iconBg: "bg-ticca-orange/10",
                      iconColor: "text-ticca-orange",
                      dark: true,
                    },
                  ].map((card, i) => (
                    <React.Fragment key={`${card.title}-${i}`}>
                      <motion.div
                        whileHover={{ y: -4, scale: 1.03 }}
                        className={`relative p-6 rounded-2xl border-2 ${card.borderColor} ${card.dark ? "bg-foreground text-background" : "bg-background"} text-center w-full md:w-[200px] flex-shrink-0`}
                      >
                        <div
                          className={`w-14 h-14 rounded-2xl ${card.dark ? "bg-background/10" : card.iconBg} flex items-center justify-center mx-auto mb-3`}
                        >
                          <span
                            className={
                              card.dark ? "text-ticca-orange" : card.iconColor
                            }
                          >
                            {card.icon}
                          </span>
                        </div>
                        <h4
                          className={`font-display font-bold text-lg mb-1.5 ${card.dark ? "" : "text-foreground"}`}
                        >
                          {card.title === "undefined" ? (
                            <span className="w-[150px]">
                              <ShimmerLoaderOneLine />
                            </span>
                          ) : (
                            parser(card.title)
                          )}
                        </h4>
                        <p
                          className={`text-xs leading-relaxed ${card.dark ? "text-background/70" : "text-muted-foreground"}`}
                        >
                          {card.desc === "undefined" ? (
                            <span className="w-[150px]">
                              <ShimmerLoaderOneLine />
                            </span>
                          ) : (
                            parser(card.desc)
                          )}
                        </p>
                      </motion.div>
                      {i < 3 && (
                        <motion.div
                          animate={{ x: [0, 4, 0] }}
                          transition={{
                            duration: 1.5,
                            repeat: Infinity,
                            delay: i * 0.15,
                          }}
                          className="hidden md:flex items-center justify-center w-10 flex-shrink-0"
                        >
                          <ArrowRight className="w-5 h-5 text-muted-foreground/50" />
                        </motion.div>
                      )}
                      {i === 2 && (
                        <motion.div
                          animate={{
                            scale: [1, 1.2, 1],
                            opacity: [0.5, 1, 0.5],
                          }}
                          transition={{ duration: 2, repeat: Infinity }}
                          className="hidden md:flex items-center justify-center w-10 flex-shrink-0"
                        >
                          <div className="w-8 h-8 rounded-full bg-ticca-green/10 flex items-center justify-center">
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="3"
                              className="text-ticca-green"
                            >
                              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                            </svg>
                          </div>
                        </motion.div>
                      )}
                    </React.Fragment>
                  ))}
                </div>

                <div className="mt-5 grid sm:grid-cols-3 gap-3">
                  {[
                    `${htmlString[186]}`,
                    `${htmlString[187]}`,
                    `${htmlString[188]}`,
                  ].map((b, i) => (
                    <div
                      key={`${b}-${i}`}
                      className="flex items-center gap-2 text-sm text-foreground p-3 rounded-lg bg-background/60 border border-border/30"
                    >
                      <CheckCircle2 className="w-4 h-4 text-ticca-blue shrink-0" />
                      {b === "undefined" ? (
                        <span className="w-full">
                          <ShimmerLoaderOneLine />
                        </span>
                      ) : (
                        parser(b)
                      )}
                    </div>
                  ))}
                </div>
                {!htmlString[189] ? (
                  <span className="w-full flex m-auto  mt-10 justify-center">
                    <ShimmerLoaderOneLine />
                  </span>
                ) : (
                  parser(htmlString[189])
                )}
              </div>
            </FadeIn>

            {/* How TICCA Works */}
            <FadeIn delay={0.2}>
              <div className="mt-6 p-5 rounded-xl bg-secondary/40 border border-border/50">
                {htmlString[190] ? (
                  parser(htmlString[190])
                ) : (
                  <div className="w-full">
                    <ShimmerLoaderOneLine />
                  </div>
                )}
                <div className="flex flex-wrap items-center gap-2 text-sm">
                  {[
                    `${htmlString[191]}`,
                    `${htmlString[192]}`,
                    `${htmlString[193]}`,
                    `${htmlString[194]}`,
                    `${htmlString[195]}`,
                    `${htmlString[196]}`,
                  ].map((step, i) => (
                    <div
                      key={`${step}-${i}`}
                      className="flex items-center gap-2"
                    >
                      <motion.span
                        whileHover={{ scale: 1.05 }}
                        className=" flex gap-[10px] items-center   px-3 py-1.5 rounded-full bg-ticca-blue/8 text-foreground font-medium border border-ticca-blue/15 whitespace-nowrap"
                      >
                        <span className="text-ticca-blue font-bold mr-1">
                          {step !== "undefined" && i + 1}.
                        </span>
                        {step === "undefined" ? (
                          <div className="w-[160px]">
                            <ShimmerLoaderOneLine />
                          </div>
                        ) : (
                          parser(step)
                        )}
                      </motion.span>
                      {i < 5 && (
                        <span className="text-muted-foreground hidden md:inline">
                          -&gt;
                        </span>
                      )}
                    </div>
                  ))}
                </div>
                <div className="mt-3 p-3 rounded-lg bg-ticca-blue/5 border border-ticca-blue/10">
                  {htmlString[196] ? (
                    parser(htmlString[197])
                  ) : (
                    <div className="w-full">
                      <ShimmerLoaderOneLine />
                    </div>
                  )}
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.25}>
              <div className="mt-5 text-center">
                <motion.button
                  onClick={() => setLlmOpen(true)}
                  animate={{
                    boxShadow: [
                      "0 0 0 0 rgba(34,197,94,0.20)",
                      "0 0 0 10px rgba(34,197,94,0)",
                      "0 0 0 0 rgba(34,197,94,0.20)",
                    ],
                  }}
                  transition={{
                    duration: 2.2,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }}
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.97 }}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-ticca-green text-white text-sm font-semibold border border-ticca-green/70 ring-2 ring-ticca-green/30 shadow-lg shadow-ticca-green/30 hover:bg-ticca-green/90 transition-colors"
                >
                  <ExternalLink className="w-4 h-4" />
                  Learn about LLM Problem & Solution
                </motion.button>
              </div>
            </FadeIn>

            <LLMProblemSolutionModal
              open={llmOpen}
              onClose={() => setLlmOpen(false)}
            />
          </div>
        </section>
        <section className="py-16 relative">
          <div className="absolute inset-0 bg-dot-pattern opacity-10" />
          <div className="container relative">
            <FadeIn>
              <SectionLabel label="Product Overview" color="blue" />
              {htmlString[198] ? (
                parser(htmlString[198])
              ) : (
                <div className="w-full mt-10 mb-10">
                  <ShimmerLoaderOneLine />
                </div>
              )}
              {htmlString[199] ? (
                parser(htmlString[199])
              ) : (
                <div className="w-full mt-10 mb-10">
                  <ShimmerLoaderOneLine />
                </div>
              )}
            </FadeIn>

            {/* Core Modules */}
            <FadeIn delay={0.05}>
              <div className="mb-5">
                <h3 className="font-display font-bold text-lg mb-4 text-foreground">
                  Core Modules (MVP)
                </h3>
                <StaggerContainer className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  {coreModules.map((mod, i) => (
                    <StaggerItem key={i}>
                      <motion.div
                        whileHover={{ y: -3, scale: 1.02 }}
                        className={`p-5 rounded-xl ${mod.bg} border ${mod.border} text-center h-full`}
                      >
                        <div
                          className={`${mod.color} flex justify-center mb-3`}
                        >
                          {mod.icon}
                        </div>
                        <span className="text-sm font-bold text-foreground">
                          {" "}
                          {mod.label === "undefined" ? (
                            <ShimmerLoaderOneLine />
                          ) : (
                            parser(mod.label)
                          )}
                        </span>
                      </motion.div>
                    </StaggerItem>
                  ))}
                </StaggerContainer>
              </div>
            </FadeIn>

            {/* Coming Soon */}
            <FadeIn delay={0.1}>
              <div className="mb-5 p-5 rounded-xl bg-secondary/30 border border-border/50">
                <h3 className="font-display font-bold text-base mb-3 text-foreground flex items-center gap-2">
                  <Sparkles className="w-4 h-4 text-ticca-blue" />{" "}
                  {htmlString[202] ? "Coming Soon" : <ShimmerLoaderOneLine />}
                </h3>
                <div className="grid sm:grid-cols-3 gap-3">
                  {comingSoon.map((item, i) => (
                    <>
                      {item.label === "undefined" ? (
                        <div
                          key={i}
                          className="flex items-center gap-2.5 p-3 rounded-lg bg-background/60 border border-border/30"
                        >
                          <ShimmerLoaderOneLine />
                        </div>
                      ) : (
                        <div
                          key={i}
                          className="flex items-center gap-2.5 p-3 rounded-lg bg-background/60 border border-border/30"
                        >
                          <span className={item.color}>{item.icon}</span>
                          <span className="text-sm font-medium text-muted-foreground">
                            {parser(item.label)}
                          </span>
                        </div>
                      )}
                    </>
                  ))}
                </div>
              </div>
            </FadeIn>

            {/* Day 1 User Experience */}
            <FadeIn delay={0.15}>
              <div className="p-5 rounded-xl bg-ticca-blue/[0.03] border border-ticca-blue/15">
                {htmlString[211] ? (
                  parser(htmlString[211])
                ) : (
                  <ShimmerLoaderwhite />
                )}
                <div className="flex flex-col gap-2 mb-4">
                  {day1Steps.map((step, i) => (
                    <motion.div
                      key={i}
                      initial={{ opacity: 0, x: -15 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: i * 0.08 }}
                      className="flex items-center gap-3"
                    >
                      <div className="w-7 h-7 rounded-full bg-ticca-blue/10 border border-ticca-blue/20 flex items-center justify-center shrink-0">
                        <span className="text-xs font-bold text-ticca-blue">
                          {i + 1}
                        </span>
                      </div>
                      {step === "undefined" ? (
                        <ShimmerLoaderOneLine />
                      ) : (
                        <span className="text-sm text-muted-foreground">
                          {parser(step)}
                        </span>
                      )}
                      {i < day1Steps.length - 1 && (
                        <motion.span
                          animate={{ y: [0, 2, 0] }}
                          transition={{
                            duration: 1.5,
                            repeat: Infinity,
                            delay: i * 0.1,
                          }}
                          className="hidden"
                        />
                      )}
                    </motion.div>
                  ))}
                </div>
                <div className="p-3 rounded-lg bg-ticca-green/5 border border-ticca-green/10">
                  {htmlString[217] ? (
                    parser(htmlString[217])
                  ) : (
                    <div className="w-full">
                      <ShimmerLoaderOneLine />
                    </div>
                  )}
                </div>
              </div>
            </FadeIn>
          </div>
        </section>
        <section className="py-14 relative">
          <div className="container">
            <FadeIn>
              <SectionLabel label="AI Work Attribution" color="green" />
              {htmlString[218] ? (
                parser(htmlString[218])
              ) : (
                <div className="w-full mt-10 mb-10">
                  <ShimmerLoaderOneLine />
                </div>
              )}
            </FadeIn>

            <div className="grid md:grid-cols-2 gap-4">
              <FadeIn delay={0.05}>
                <div className="p-5 rounded-xl bg-secondary/40 border border-border/50 h-full">
                  {htmlString[219] ? (
                    <h3 className="font-display font-bold text-base mb-3 text-foreground flex items-center gap-2">
                      <Activity className="w-4 h-4 text-ticca-blue" />{" "}
                      {parser(htmlString[219])}
                    </h3>
                  ) : (
                    <div className="w-full">
                      <ShimmerLoaderOneLine />
                    </div>
                  )}
                  <div className="space-y-2">
                    {[
                      `${htmlString[220]}`,
                      `${htmlString[221]}`,
                      `${htmlString[222]}`,
                      `${htmlString[223]}`,
                    ].map((item, index) => (
                      <div
                        key={`item-${index}`}
                        className="flex items-start gap-2 text-sm text-muted-foreground"
                      >
                        <span className="w-1.5 h-1.5 rounded-full bg-ticca-blue mt-2 shrink-0" />
                        {item === "undefined" ? (
                          <ShimmerLoaderOneLine />
                        ) : (
                          parser(item)
                        )}
                      </div>
                    ))}
                  </div>
                  {htmlString[224] ? (
                    parser(htmlString[224])
                  ) : (
                    <div className="w-full mt-3">
                      <ShimmerLoaderOneLine />
                    </div>
                  )}
                </div>
              </FadeIn>

              <FadeIn delay={0.1}>
                <div className="p-5 rounded-xl bg-ticca-green/[0.03] border border-ticca-green/15 h-full">
                  {htmlString[226] ? (
                    <h3 className="font-display font-bold text-base mb-3 text-foreground flex items-center gap-2">
                      <Bot className="w-4 h-4 text-ticca-green" />{" "}
                      {parser(htmlString[226])}
                    </h3>
                  ) : (
                    <div className="w-full mt-3">
                      <ShimmerLoaderOneLine />
                    </div>
                  )}
                  <div className="space-y-2">
                    {[
                      {
                        icon: <Activity className="w-3.5 h-3.5" />,
                        label: `${htmlString[226]}`,
                      },
                      {
                        icon: <Tag className="w-3.5 h-3.5" />,
                        label: `${htmlString[227]}`,
                      },
                      {
                        icon: <GitBranch className="w-3.5 h-3.5" />,
                        label: `${htmlString[228]}`,
                      },
                      {
                        icon: <BarChart3 className="w-3.5 h-3.5" />,
                        label: `${htmlString[229]}`,
                      },
                    ].map((item, i) => (
                      <div
                        key={`${item.label}-${i}-23232`}
                        className="flex items-start gap-2 text-sm text-muted-foreground"
                      >
                        <span className="text-ticca-green mt-0.5 shrink-0">
                          {item.icon}
                        </span>
                        {item.label === "undefined" ? (
                          <ShimmerLoaderOneLine />
                        ) : (
                          <span>{parser(item.label)}</span>
                        )}
                      </div>
                    ))}
                  </div>
                  {htmlString[230] ? (
                    parser(htmlString[230])
                  ) : (
                    <div className="w-full mt-3">
                      <ShimmerLoaderOneLine />
                    </div>
                  )}
                </div>
              </FadeIn>
            </div>

            {/* Attribution flow - prominent card-based steps */}
            <FadeIn delay={0.15}>
              <div className="mt-6 p-5 rounded-2xl bg-secondary/20 border border-border/40">
                {htmlString[231] ? (
                  parser(htmlString[231])
                ) : (
                  <div className="w-full mt-3 m-auto  flex justify-center">
                    <ShimmerLoaderOneLine />
                  </div>
                )}
                <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-0">
                  {[
                    {
                      label: `${htmlString[232]}`,
                      icon: "👤",
                      bg: "bg-ticca-blue/10",
                      border: "border-ticca-blue/30",
                      text: "text-ticca-blue",
                    },
                    {
                      label: `${htmlString[233]}`,
                      icon: "🤝",
                      bg: "bg-ticca-orange/10",
                      border: "border-ticca-orange/30",
                      text: "text-ticca-orange",
                    },
                    {
                      label: `${htmlString[234]}`,
                      icon: "🤖",
                      bg: "bg-ticca-green/10",
                      border: "border-ticca-green/30",
                      text: "text-ticca-green",
                    },
                    {
                      label: `${htmlString[235]}`,
                      icon: "📊",
                      bg: "bg-ticca-blue/10",
                      border: "border-ticca-blue/30",
                      text: "text-ticca-blue",
                    },
                  ].map((item, i) => (
                    <React.Fragment key={`${item.label}-${i}`}>
                      <motion.div
                        key={`${item.label}-${i}`}
                        whileHover={{ y: -4, scale: 1.04 }}
                        className={`flex flex-col items-center gap-2 px-6 py-4 rounded-xl ${item.bg} border-2 ${item.border} cursor-default min-w-[140px]`}
                      >
                        {item.label === "undefined" ? (
                          <ShimmerLoaderOneLine />
                        ) : (
                          <>
                            <span className="text-2xl">{item.icon}</span>
                            <span className={`text-sm font-bold ${item.text}`}>
                              {parser(item.label)}
                            </span>
                          </>
                        )}
                      </motion.div>
                      {i < 3 && (
                        <motion.div
                          animate={{ x: [0, 5, 0] }}
                          transition={{
                            duration: 1.5,
                            repeat: Infinity,
                            delay: i * 0.15,
                          }}
                          className="hidden sm:flex items-center justify-center w-8 flex-shrink-0"
                        >
                          <ArrowRight className="w-5 h-5 text-muted-foreground/40" />
                        </motion.div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </FadeIn>
          </div>
        </section>
        <section className="py-14 relative">
          <div className="container">
            <FadeIn>
              <div className="text-center mb-6">
                {htmlString[236] ? (
                  <h2 className="font-display font-bold text-2xl text-foreground">
                    {parser(htmlString[240])}
                  </h2>
                ) : (
                  <div className="w-full mt-3 m-auto  flex justify-center">
                    <ShimmerLoaderOneLine />
                  </div>
                )}
              </div>
            </FadeIn>

            <FadeIn delay={0.05}>
              <div className="p-5 rounded-2xl bg-secondary/20 border border-border/40 mb-5">
                <StaggerContainer className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  {segments.map((seg, i) => (
                    <StaggerItem key={`segment-${i}`}>
                      <motion.div
                        whileHover={{ y: -3, scale: 1.02 }}
                        className="p-4 rounded-xl bg-background border border-border/50 h-full shadow-card"
                      >
                        <div
                          className={`w-10 h-10 rounded-lg ${seg.bg} flex items-center justify-center mb-2.5`}
                        >
                          <span className={seg.color}>{seg.icon}</span>
                        </div>
                        <span className="text-sm font-semibold text-foreground">
                          {seg.label === "undefined" ? (
                            <ShimmerLoaderOneLine />
                          ) : (
                            parser(seg.label)
                          )}
                        </span>
                      </motion.div>
                    </StaggerItem>
                  ))}
                </StaggerContainer>
              </div>
            </FadeIn>

            {/* Initial Market Wedge */}
            <FadeIn delay={0.08}>
              <div className="mb-5 p-5 rounded-xl bg-ticca-red/[0.03] border border-ticca-red/15">
                {htmlString[241] ? (
                  parser(htmlString[249])
                ) : (
                  <div className="w-full mt-3 m-auto  flex justify-center">
                    <ShimmerLoaderOneLine />
                  </div>
                )}

                <div className="grid md:grid-cols-2 gap-4">
                  {/* Why this segment */}
                  <div className="p-4 rounded-lg bg-ticca-orange/[0.04] border border-ticca-orange/15">
                    {htmlString[242] ? (
                      parser(htmlString[250])
                    ) : (
                      <div className="w-full mt-3 m-auto  flex justify-center">
                        <ShimmerLoaderOneLine />
                      </div>
                    )}
                    <ul className="space-y-2">
                      {s.map((item, i) => (
                        <>
                          {item.text === "undefined" ? (
                            <div className="w-full mt-3 m-auto  flex justify-center">
                              <ShimmerLoaderOneLine />
                            </div>
                          ) : (
                            <li
                              key={i}
                              className="flex items-center gap-2.5 text-sm text-muted-foreground"
                            >
                              {item.icon}
                              {parser(item.text)}
                            </li>
                          )}
                        </>
                      ))}
                    </ul>
                  </div>

                  {/* Why TICCA wins */}
                  <div className="p-4 rounded-lg bg-ticca-green/[0.04] border border-ticca-green/15">
                    {htmlString[257] ? (
                      parser(htmlString[254])
                    ) : (
                      <div className="w-full mt-3 m-auto  flex justify-center">
                        <ShimmerLoaderOneLine />
                      </div>
                    )}
                    <ul className="space-y-2">
                      {whyWins.map((item, i) => (
                        <>
                          {item.text === "undefined" ? (
                            <div className="w-full mt-3 m-auto  flex justify-center">
                              <ShimmerLoaderOneLine />
                            </div>
                          ) : (
                            <li
                              key={i}
                              className="flex items-center gap-2.5 text-sm text-muted-foreground"
                            >
                              {item.icon}
                              {parser(item.text)}
                            </li>
                          )}
                        </>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Expansion */}
                <div className="mt-4 p-3 rounded-lg bg-ticca-blue/5 border border-ticca-blue/10">
                  {!htmlString[253] ? (
                    <div className="w-full ">
                      <ShimmerLoaderOneLine />
                    </div>
                  ) : (
                    <div className="flex items-center gap-2 mb-1">
                      <TrendingUp className="w-4 h-4 text-ticca-blue shrink-0" />
                      <span className="text-sm font-bold text-foreground">
                        {parser(htmlString[258])}
                      </span>
                    </div>
                  )}
                  <div className="flex flex-wrap gap-2 mt-2">
                    {expansionTargets.map((t, i) => (
                      <>
                        {t === "undefined" ? (
                          <div key={i} className="w-[120px]">
                            <ShimmerLoaderOneLine />
                          </div>
                        ) : (
                          <span
                            key={i}
                            className="px-3 py-1 rounded-full bg-ticca-blue/8 border border-ticca-blue/15 text-xs font-medium text-ticca-blue"
                          >
                            {parser(t)}
                          </span>
                        )}
                      </>
                    ))}
                  </div>
                </div>
              </div>
            </FadeIn>

            {/* Common Requirements */}
            <FadeIn delay={0.1}>
              <div className="p-5 rounded-2xl bg-secondary/20 border border-border/40">
                {htmlString[259] ? (
                  parser(htmlString[262])
                ) : (
                  <div className="w-full mt-3 m-auto  flex justify-center">
                    <ShimmerLoaderOneLine />
                  </div>
                )}
                <div className="grid sm:grid-cols-3 gap-4">
                  {requirements.map((req, i) => (
                    <motion.div
                      key={i}
                      whileHover={{ y: -2 }}
                      className={`p-4 rounded-xl ${req.bg} border border-border/30 text-center`}
                    >
                      {req.title === "undefined" ? (
                        <div className="w-full mt-3 m-auto  flex justify-center">
                          <ShimmerLoaderwhite />
                        </div>
                      ) : (
                        <>
                          {" "}
                          <div className="w-10 h-10 rounded-lg bg-background flex items-center justify-center mx-auto mb-2.5 shadow-card">
                            {req.icon}
                          </div>
                          <h4 className="font-display font-bold text-sm text-foreground mb-1">
                            {parser(req.title)}
                          </h4>
                          <p className="text-xs text-muted-foreground">
                            {parser(req.desc)}
                          </p>
                        </>
                      )}
                    </motion.div>
                  ))}
                </div>
              </div>
            </FadeIn>
          </div>
        </section>
        <section className="py-14 relative">
          <div className="container">
            <FadeIn>
              <div className="text-center mb-6">
                <SectionLabel label="Competitive Edge" color="blue" />
                {htmlString[263] ? (
                  <h2 className="font-display font-bold text-3xl md:text-4xl mt-3 mb-2 text-foreground">
                    {parser(htmlString[269])}
                  </h2>
                ) : (
                  <div className="w-full mt-3 m-auto  flex justify-center">
                    <ShimmerLoaderwhite />
                  </div>
                )}
              </div>
            </FadeIn>

            <StaggerContainer className="grid md:grid-cols-2 gap-4 mb-6">
              {advantages.map((adv, i) => (
                <StaggerItem key={i}>
                  <motion.div
                    whileHover={{ y: -3, scale: 1.01 }}
                    className={`p-5 rounded-xl border ${adv.border} ${adv.bg} h-full shadow-card`}
                    style={{ borderColor: "#E3E8EF", color: "#111827" }}
                  >
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 rounded-xl bg-secondary/60 flex items-center justify-center">
                        {adv.icon}
                      </div>
                      {adv.badge === "undefined" ? (
                        <ShimmerLoaderOneLine />
                      ) : (
                        <span
                          className={`px-2.5 py-0.5 rounded-md text-xs font-bold uppercase ${adv.badgeBg}`}
                        >
                          {parser(adv.badge)}
                        </span>
                      )}
                    </div>
                    {adv.title === "undefined" ? (
                      <div className="w-full mt-3 m-auto  flex justify-center">
                        <ShimmerLoaderOneLine />
                      </div>
                    ) : (
                      <h4 className="font-display font-bold text-sm text-foreground mb-1">
                        {parser(adv.title)}
                      </h4>
                    )}
                  </motion.div>
                </StaggerItem>
              ))}
            </StaggerContainer>

            {/* How TICCA Compares table */}
            <FadeIn delay={0.15}>
              <div className="p-5 rounded-2xl bg-background border border-border/50 shadow-card">
                {htmlString[279] ? (
                  <h3 className="font-display font-bold text-base mb-4 text-foreground">
                    {parser(htmlString[278])}
                  </h3>
                ) : (
                  <div className="w-full mt-3 m-auto  flex justify-center">
                    <ShimmerLoaderOneLine />
                  </div>
                )}
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead>
                      <tr>
                        <th className="text-left text-sm font-bold text-foreground py-3 px-4">
                          Feature
                        </th>
                        <th className="text-center text-sm font-bold text-muted-foreground py-3 px-4">
                          Traditional Tools
                        </th>
                        <th className="text-center text-sm font-bold text-ticca-blue py-3 px-4 bg-ticca-blue/5 rounded-t-lg">
                          TICCA
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {comparisonRows.map((row, i) => (
                        <tr key={i} className="border-t border-border/30">
                          <td className="text-sm text-ticca-blue py-3 px-4">
                            {row.feature === "undefined" ? (
                              <ShimmerLoaderOneLine />
                            ) : (
                              parser(row.feature)
                            )}
                          </td>
                          <td className="text-center py-3 px-4">
                            {typeof row.traditional === "string" ? (
                              <span className="text-sm text-muted-foreground">
                                {row.traditional}
                              </span>
                            ) : (
                              <XCircle className="w-5 h-5 text-ticca-red/40 mx-auto" />
                            )}
                          </td>
                          <td className="text-center py-3 px-4 bg-ticca-green/5">
                            {typeof row.ticca === "string" ? (
                              <span className="text-sm font-semibold text-ticca-green">
                                {row.ticca}
                              </span>
                            ) : (
                              <CheckCircle2 className="w-5 h-5 text-ticca-green mx-auto" />
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </FadeIn>
          </div>
        </section>
        <section id="why-now" className="py-16 relative">
          <div className="absolute inset-0">
            <div className="absolute top-1/3 right-0 w-[300px] h-[300px] bg-ticca-orange/3 rounded-full blur-[100px]" />
          </div>
          <div className="container relative">
            <FadeIn>
              <SectionLabel label="Why Now" color="orange" />
              {htmlString[280] ? (
                parser(htmlString[285])
              ) : (
                <div className="w-full mt-3 ">
                  <ShimmerLoaderwhite />
                </div>
              )}
            </FadeIn>

            <StaggerContainer className="grid md:grid-cols-3 gap-5">
              {shifts.map((shift, i) => (
                <StaggerItem key={i}>
                  <motion.div
                    whileHover={{ y: -4, scale: 1.01 }}
                    className={`p-5 rounded-xl border ${shift.borderColor} ${shift.bgColor} h-full`}
                  >
                    <div className="flex items-center gap-2 mb-3">
                      <span className={shift.color}>{shift.icon}</span>
                      {shift.title === "undefined" ? (
                        <ShimmerLoaderOneLine />
                      ) : (
                        <h3 className="font-display font-bold text-base text-foreground">
                          {parser(shift.title)}
                        </h3>
                      )}
                    </div>
                    {shift.desc === "undefined" ? (
                      <ShimmerLoaderOneLine />
                    ) : (
                      <p className="text-sm text-muted-foreground mb-3">
                        {parser(shift.desc)}
                      </p>
                    )}
                    <ul className="space-y-2 mb-3">
                      {shift.points.map((point, j) => (
                        <li
                          key={j}
                          className="flex items-start gap-2 text-sm text-muted-foreground"
                        >
                          <ArrowRight
                            className={`w-3.5 h-3.5 mt-0.5 shrink-0 ${shift.color}`}
                          />
                          {point === "undefined" ? (
                            <ShimmerLoaderOneLine />
                          ) : (
                            parser(point)
                          )}
                        </li>
                      ))}
                    </ul>
                    {shift.conclusion && htmlString[291] && (
                      <div className="p-2.5 rounded-lg bg-ticca-blue/5 border border-ticca-blue/10">
                        <p className="text-sm font-semibold text-foreground flex items-center gap-2">
                          <AlertTriangle className="w-3.5 h-3.5 text-ticca-blue shrink-0" />
                          {parser(shift.conclusion)}
                        </p>
                      </div>
                    )}
                  </motion.div>
                </StaggerItem>
              ))}
            </StaggerContainer>

            <FadeIn delay={0.2}>
              <div className="mt-6 p-4 rounded-xl bg-ticca-orange/[0.03] border border-ticca-orange/15">
                <div className="flex items-center gap-2">
                  <Zap className="w-4 h-4 text-ticca-orange" />

                  {typeof htmlString[302] !== "string" ? (
                    <ShimmerLoaderOneLine />
                  ) : (
                    parser(htmlString[302])
                  )}
                </div>
              </div>
            </FadeIn>
          </div>
        </section>
        <section id="defensibility" className="py-16 relative">
          <div className="absolute inset-0">
            <div className="absolute bottom-0 left-1/4 w-[250px] h-[250px] bg-ticca-green/3 rounded-full blur-[80px]" />
          </div>
          <div className="container relative">
            <FadeIn>
              <SectionLabel label="Defensibility" color="green" />
              {typeof htmlString[302] !== "string" ? (
                <div className="w-full mt-3 ">
                  <ShimmerLoaderwhite />
                </div>
              ) : (
                parser(htmlString[303])
              )}
            </FadeIn>

            <StaggerContainer className="grid md:grid-cols-2 gap-5">
              {pillars.map((pillar, i) => (
                <StaggerItem key={i}>
                  <motion.div
                    whileHover={{ y: -4, scale: 1.01 }}
                    className={`p-5 rounded-xl border ${pillar.borderColor} ${pillar.bgColor} h-full`}
                  >
                    <div className="flex items-center gap-2 mb-4">
                      <span className={pillar.color}>{pillar.icon}</span>
                      <h3 className="font-display font-bold text-base text-foreground">
                        {" "}
                        {!htmlString[318] ? (
                          <ShimmerLoaderOneLine />
                        ) : (
                          parser(pillar.title)
                        )}
                      </h3>
                    </div>
                    {pillar.content}
                  </motion.div>
                </StaggerItem>
              ))}
            </StaggerContainer>

            <FadeIn delay={0.2}>
              <div className="mt-6 p-4 rounded-xl bg-ticca-green/[0.03] border border-ticca-green/15">
                <div className="flex items-center gap-2">
                  <Lock className="w-4 h-4 text-ticca-green" />

                  {typeof htmlString[329] !== "string" ? (
                    <ShimmerLoaderOneLine />
                  ) : (
                    parser(htmlString[329])
                  )}
                </div>
              </div>
            </FadeIn>
          </div>
        </section>
        <section className="py-16 relative">
          <div className="absolute inset-0">
            <div className="absolute top-1/3 right-0 w-[300px] h-[300px] bg-ticca-blue/3 rounded-full blur-[100px]" />
          </div>
          <div className="container relative">
            <FadeIn>
              <SectionLabel label="Compounding Advantage" color="blue" />
              {typeof htmlString[330] !== "string" ? (
                <div className="mt-[10px] mb-[10px]">
                  {" "}
                  <ShimmerLoaderwhite />{" "}
                </div>
              ) : (
                parser(htmlString[330])
              )}
            </FadeIn>

            {/* Data graph visual */}
            <FadeIn delay={0.05}>
              <div className="p-6 rounded-2xl bg-secondary/30 border border-border/50 mb-6">
                <div className="flex items-center gap-2 mb-4">
                  <BrainCircuit className="w-5 h-5 text-ticca-blue" />
                  {typeof htmlString[331] !== "string" ? (
                    <ShimmerLoaderOneLine />
                  ) : (
                    parser(htmlString[331])
                  )}
                </div>
                {typeof htmlString[332] !== "string" ? (
                  <ShimmerLoaderOneLine />
                ) : (
                  parser(htmlString[332])
                )}

                <StaggerContainer className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
                  {datasets.map((d, i) => (
                    <StaggerItem key={d.label}>
                      <motion.div
                        whileHover={{ y: -3, scale: 1.02 }}
                        className={`p-4 rounded-xl ${d.bg} border ${d.border} text-center`}
                      >
                        <div className={`${d.color} flex justify-center mb-2`}>
                          {d.icon}
                        </div>
                        <span className="text-sm font-semibold text-foreground">
                          {htmlString[333 + i] ? (
                            parser(htmlString[333 + i])
                          ) : (
                            <ShimmerLoaderOneLine />
                          )}
                        </span>
                      </motion.div>
                    </StaggerItem>
                  ))}
                </StaggerContainer>

                {/* Compounding visual */}
                <div className="flex items-center gap-3 p-4 rounded-xl bg-ticca-blue/[0.03] border border-ticca-blue/10">
                  <TrendingUp className="w-5 h-5 text-ticca-blue shrink-0" />
                  {htmlString[337] ? (
                    parser(htmlString[337])
                  ) : (
                    <div className="w-full mt-3 m-auto">
                      <ShimmerLoaderOneLine />
                    </div>
                  )}
                </div>
              </div>
            </FadeIn>

            {/* Workflow Lock-In */}
            <FadeIn delay={0.1}>
              <div className="p-6 rounded-2xl bg-ticca-orange/[0.02] border border-ticca-orange/15">
                <div className="flex items-center gap-2 mb-4">
                  <Lock className="w-5 h-5 text-ticca-orange" />
                  {htmlString[338] ? (
                    parser(htmlString[338])
                  ) : (
                    <div className="w-full mt-3 ">
                      <ShimmerLoaderOneLine />
                    </div>
                  )}
                </div>
                {htmlString[339] ? (
                  parser(htmlString[339])
                ) : (
                  <div className="w-full mt-3 ">
                    <ShimmerLoaderOneLine />
                  </div>
                )}

                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
                  {lockInItems.map((item, i) => (
                    <motion.div
                      key={`${item.label}-${i}`}
                      whileHover={{ y: -2, scale: 1.02 }}
                      className={`p-4 rounded-xl border ${item.color} text-center`}
                    >
                      <span className="text-sm font-bold text-foreground">
                        {htmlString[340 + i] ? (
                          parser(htmlString[340 + i])
                        ) : (
                          <ShimmerLoaderOneLine />
                        )}
                      </span>
                    </motion.div>
                  ))}
                </div>

                <div className="p-3 rounded-lg bg-ticca-orange/5 border border-ticca-orange/10">
                  {htmlString[344] ? (
                    parser(htmlString[344])
                  ) : (
                    <div className="w-full mt-3 m-auto">
                      <ShimmerLoaderOneLine />
                    </div>
                  )}
                </div>
              </div>
            </FadeIn>
          </div>
        </section>
        <section id="icp" className="py-16 relative">
          <div className="absolute inset-0">
            <div className="absolute top-1/2 right-0 w-[200px] h-[200px] bg-ticca-blue/3 rounded-full blur-[80px]" />
          </div>
          <div className="container relative">
            <FadeIn>
              <SectionLabel label="Initial Target Market" color="red" />
              {htmlString[345] ? (
                <h2 className="font-display font-bold text-3xl md:text-4xl mt-3 mb-2 text-foreground">
                  {parser(htmlString[345])}
                </h2>
              ) : (
                <div className="w-full mt-3">
                  <ShimmerLoaderwhite />
                </div>
              )}
            </FadeIn>

            <div className="grid md:grid-cols-[1fr,1fr] gap-6">
              {/* Target segment highlight */}
              <FadeIn delay={0.05}>
                <div className="p-6 rounded-xl bg-ticca-red/[0.04] border border-ticca-red/20 h-full">
                  <div className="flex items-center gap-3 mb-5">
                    <div className="w-10 h-10 rounded-xl bg-ticca-red/10 flex items-center justify-center">
                      <Users className="w-5 h-5 text-ticca-red" />
                    </div>
                    <div>
                      {htmlString[346] ? (
                        parser(htmlString[346])
                      ) : (
                        <ShimmerLoaderOneLine />
                      )}
                    </div>
                  </div>

                  {htmlString[347] ? (
                    parser(htmlString[347])
                  ) : (
                    <ShimmerLoaderOneLine />
                  )}
                  <ul className="space-y-2.5">
                    {whySegments.map((item, i) => (
                      <li
                        key={i}
                        className="flex items-start gap-2.5 text-sm text-muted-foreground"
                      >
                        {item.icon}
                        {htmlString[348 + i] ? (
                          parser(htmlString[348 + i])
                        ) : (
                          <ShimmerLoaderOneLine />
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </FadeIn>

              {/* Why TICCA wins */}
              <FadeIn delay={0.1}>
                <div className="p-6 rounded-xl bg-ticca-green/[0.04] border border-ticca-green/20 h-full flex flex-col">
                  {htmlString[353] ? (
                    parser(htmlString[351])
                  ) : (
                    <div className="w-full mt-3">
                      <ShimmerLoaderOneLine />
                    </div>
                  )}
                  <StaggerContainer className="space-y-3 flex-1">
                    {whyWinss.map((item, i) => (
                      <StaggerItem key={`whyWins-${i}-${item.text}`}>
                        <motion.div
                          whileHover={{ x: 3 }}
                          className="flex items-start gap-2.5 text-sm text-foreground/80 p-3 rounded-lg bg-background/50 border border-border/30"
                        >
                          {item.icon}
                          {htmlString[352 + i] ? (
                            <span className="font-medium">
                              {parser(htmlString[352 + i])}
                            </span>
                          ) : (
                            <ShimmerLoaderOneLine />
                          )}
                        </motion.div>
                      </StaggerItem>
                    ))}
                  </StaggerContainer>

                  <div className="mt-4 p-3 rounded-lg bg-ticca-blue/5 border border-ticca-blue/10">
                    <div className="flex items-center gap-2">
                      <TrendingUp className="w-4 h-4 text-ticca-blue shrink-0" />
                      {htmlString[355] ? (
                        parser(htmlString[355])
                      ) : (
                        <ShimmerLoaderOneLine />
                      )}
                    </div>
                  </div>
                </div>
              </FadeIn>
            </div>
          </div>
        </section>
        <section id="market" className="py-20 relative">
          <div className="absolute inset-0 bg-grid-pattern opacity-10" />
          <div className="container relative">
            {/* Section Header */}
            <FadeIn>
              <div className="max-w-2xl mb-12">
                <SectionLabel label="Market Opportunity" color="green" />
                {htmlString[356] ? (
                  parser(htmlString[356])
                ) : (
                  <div className="w-full mt-[10px] mb-[10px]">
                    <ShimmerLoaderwhite />
                  </div>
                )}
              </div>
            </FadeIn>

            <div className="grid md:grid-cols-[1fr,1fr] gap-10 items-center">
              {/* TAM SAM SOM Concentric Circles */}
              <FadeIn delay={0.1}>
                <div className="relative flex items-center justify-center py-4">
                  <div className="relative w-[320px] h-[320px] md:w-[380px] md:h-[380px]">
                    {/* TAM */}
                    <motion.div
                      initial={{ scale: 0, opacity: 0 }}
                      whileInView={{ scale: 1, opacity: 1 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.6, delay: 0 }}
                      className="absolute inset-0 rounded-full border-2 border-ticca-blue/30 bg-ticca-blue/[0.04]"
                    >
                      <div className="absolute top-5 left-1/2 -translate-x-1/2 text-center">
                        <span className="text-sm font-bold text-ticca-blue uppercase tracking-wider">
                          TAM
                        </span>
                        <p className="text-xs text-muted-foreground mt-0.5">
                          $134B+ in 2024
                        </p>
                      </div>
                    </motion.div>

                    {/* SAM */}
                    <motion.div
                      initial={{ scale: 0, opacity: 0 }}
                      whileInView={{ scale: 1, opacity: 1 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.6, delay: 0.2 }}
                      className="absolute rounded-full border-2 border-ticca-orange/40 bg-ticca-orange/[0.06]"
                      style={{
                        top: "20%",
                        left: "20%",
                        right: "20%",
                        bottom: "20%",
                      }}
                    >
                      <div className="absolute top-4 left-1/2 -translate-x-1/2 text-center">
                        <span className="text-sm font-bold text-ticca-orange uppercase tracking-wider">
                          SAM
                        </span>
                        <p className="text-xs text-muted-foreground mt-0.5">
                          $45B
                        </p>
                      </div>
                    </motion.div>

                    {/* SOM */}
                    <motion.div
                      initial={{ scale: 0, opacity: 0 }}
                      whileInView={{ scale: 1, opacity: 1 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.6, delay: 0.4 }}
                      className="absolute rounded-full border-2 border-ticca-green/50 bg-ticca-green/[0.08] flex items-center justify-center"
                      style={{
                        top: "38%",
                        left: "38%",
                        right: "38%",
                        bottom: "38%",
                      }}
                    >
                      <div className="text-center">
                        <span className="text-sm font-bold text-ticca-green uppercase tracking-wider">
                          SOM
                        </span>
                        <p className="text-xs text-muted-foreground mt-0.5">
                          $400M-$500M
                        </p>
                      </div>
                    </motion.div>

                    {/* Pulsing ring */}
                    <motion.div
                      animate={{ scale: [1, 1.15, 1], opacity: [0.4, 0, 0.4] }}
                      transition={{ duration: 2.5, repeat: Infinity }}
                      className="absolute rounded-full border border-ticca-green/30"
                      style={{
                        top: "38%",
                        left: "38%",
                        right: "38%",
                        bottom: "38%",
                      }}
                    />
                  </div>
                </div>
              </FadeIn>

              {/* Market descriptions */}
              <div className="space-y-4">
                <FadeIn delay={0.15}>
                  <motion.div
                    whileHover={{ x: 4 }}
                    className="p-5 rounded-2xl border border-ticca-blue/20 bg-ticca-blue/[0.03] transition-all"
                  >
                    <div className="flex items-center gap-2.5 mb-2">
                      <div className="w-3 h-3 rounded-full bg-ticca-blue shadow-[0_0_8px_hsl(var(--ticca-blue)/0.4)]" />
                      {htmlString[357] ? (
                        parser(htmlString[357])
                      ) : (
                        <ShimmerLoaderOneLine />
                      )}
                    </div>
                    {htmlString[358] ? (
                      parser(htmlString[358])
                    ) : (
                      <ShimmerLoaderwhite />
                    )}
                  </motion.div>
                </FadeIn>

                <FadeIn delay={0.2}>
                  <motion.div
                    whileHover={{ x: 4 }}
                    className="p-5 rounded-2xl border border-ticca-orange/20 bg-ticca-orange/[0.03] transition-all"
                  >
                    <div className="flex items-center gap-2.5 mb-2">
                      <div className="w-3 h-3 rounded-full bg-ticca-orange shadow-[0_0_8px_hsl(var(--ticca-orange)/0.4)]" />
                      {htmlString[359] ? (
                        parser(htmlString[359])
                      ) : (
                        <ShimmerLoaderOneLine />
                      )}
                    </div>
                    {htmlString[360] ? (
                      parser(htmlString[360])
                    ) : (
                      <ShimmerLoaderwhite />
                    )}
                  </motion.div>
                </FadeIn>

                <FadeIn delay={0.25}>
                  <motion.div
                    whileHover={{ x: 4 }}
                    className="p-5 rounded-2xl border border-ticca-green/20 bg-ticca-green/[0.03] transition-all"
                  >
                    <div className="flex items-center gap-2.5 mb-2">
                      <div className="w-3 h-3 rounded-full bg-ticca-green shadow-[0_0_8px_hsl(var(--ticca-green)/0.4)]" />
                      {htmlString[361] ? (
                        parser(htmlString[361])
                      ) : (
                        <ShimmerLoaderOneLine />
                      )}
                    </div>
                    {htmlString[362] ? (
                      parser(htmlString[362])
                    ) : (
                      <ShimmerLoaderwhite />
                    )}
                  </motion.div>
                </FadeIn>
              </div>
            </div>

            {/* Market Intersection */}
            <FadeIn delay={0.3}>
              <div className="mt-12 p-6 md:p-8 rounded-2xl bg-secondary/30 border border-border/40">
                <div className="flex items-center justify-center gap-2 mb-6">
                  <TrendingUp className="w-5 h-5 text-ticca-green" />
                  {htmlString[363] ? (
                    parser(htmlString[363])
                  ) : (
                    <ShimmerLoaderOneLine />
                  )}
                </div>
                <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-6">
                  {[
                    {
                      label: "Workforce productivity software",
                      color: "text-ticca-blue",
                      bg: "bg-ticca-blue/8",
                      border: "border-ticca-blue/15",
                    },
                    {
                      label: "HR technology",
                      color: "text-ticca-red",
                      bg: "bg-ticca-red/8",
                      border: "border-ticca-red/15",
                    },
                    {
                      label: "Collaboration platforms",
                      color: "text-ticca-green",
                      bg: "bg-ticca-green/8",
                      border: "border-ticca-green/15",
                    },
                    {
                      label: "Project management systems",
                      color: "text-ticca-orange",
                      bg: "bg-ticca-orange/8",
                      border: "border-ticca-orange/15",
                    },
                    {
                      label: "AI workflow tooling",
                      color: "text-ticca-blue",
                      bg: "bg-ticca-blue/8",
                      border: "border-ticca-blue/15",
                    },
                  ].map((item, i) => (
                    <motion.div
                      key={i}
                      whileHover={{ y: -3, scale: 1.03 }}
                      className={`p-4 rounded-xl ${item.bg} border ${item.border} text-center`}
                    >
                      {htmlString[364 + i] ? (
                        <span className={`text-xs font-semibold ${item.color}`}>
                          {parser(htmlString[364 + i])}
                        </span>
                      ) : (
                        <ShimmerLoaderOneLine />
                      )}
                    </motion.div>
                  ))}
                </div>
                <div className="text-center p-5 rounded-2xl bg-ticca-green/[0.06] border border-ticca-green/20">
                  {htmlString[369] ? (
                    <>{parser(htmlString[369])}</>
                  ) : (
                    <ShimmerLoaderOneLine />
                  )}
                </div>
              </div>
            </FadeIn>
          </div>
        </section>
        <section id="model" className="py-16 relative">
          <div className="container">
            <FadeIn>
              <div className="text-center mb-6">
                <SectionLabel label="Business Model" color="orange" />
                {htmlString[370] ? (
                  parser(htmlString[370])
                ) : (
                  <div className="m-auto mt-[20px] mb-[10px] flex w-full  justify-center gap-2">
                    <ShimmerLoaderOneLine />
                  </div>
                )}
              </div>
            </FadeIn>

            {/* Subscription Tiers - card style like reference */}
            <FadeIn delay={0.05}>
              <div className="p-5 rounded-2xl bg-secondary/20 border border-border/40 mb-5">
                <h3 className="font-display font-bold text-lg mb-4 text-foreground text-center">
                  Subscription Tiers
                </h3>
                <div className="flex items-end justify-center gap-3 md:gap-4 mb-3">
                  {tiers.map((tier, i) => (
                    <motion.div
                      key={tier.name}
                      initial={{ y: 20, opacity: 0 }}
                      whileInView={{ y: 0, opacity: 1 }}
                      viewport={{ once: true }}
                      transition={{ delay: i * 0.08 }}
                      whileHover={{ y: -4, scale: 1.03 }}
                      className={`${tier.color} ${tier.textColor} rounded-xl p-4 text-center shadow-card`}
                      style={{ width: "110px", height: `${100 + i * 20}px` }}
                    >
                      <div className="flex flex-col justify-end h-full">
                        {htmlString[371 + i] ? (
                          parser(htmlString[371 + i])
                        ) : (
                          <ShimmerLoaderOneLine />
                        )}
                        <p className="font-display font-bold text-lg">
                          {tier.sub}
                        </p>
                      </div>
                    </motion.div>
                  ))}
                </div>
                {htmlString[375] ? (
                  parser(htmlString[376])
                ) : (
                  <div className="w-full m-auto flex justify-center">
                    {" "}
                    <ShimmerLoaderOneLine />{" "}
                  </div>
                )}
              </div>
            </FadeIn>

            {/* Revenue Streams - card grid like reference */}
            <StaggerContainer className="grid sm:grid-cols-3 gap-4">
              {revenueStreams.map((stream, i) => (
                <StaggerItem key={i}>
                  <motion.div
                    whileHover={{ y: -3 }}
                    className={`p-5 rounded-xl ${stream.bg} border ${stream.border} h-full`}
                  >
                    <div className="w-10 h-10 rounded-lg bg-background flex items-center justify-center mx-auto mb-3 shadow-card">
                      {stream.icon}
                    </div>
                    {stream.title == "undefined" ? (
                      <ShimmerLoaderOneLine />
                    ) : (
                      parser(stream.title)
                    )}
                    {stream.desc == "undefined" ? (
                      <ShimmerLoaderOneLine />
                    ) : (
                      parser(stream.desc)
                    )}
                    <div className="p-2.5 rounded-lg bg-background/60 border border-border/30">
                      {stream.detail == "undefined" ? (
                        <ShimmerLoaderOneLine />
                      ) : (
                        parser(stream.detail)
                      )}
                    </div>
                  </motion.div>
                </StaggerItem>
              ))}
            </StaggerContainer>

            <FadeIn delay={0.15}>
              <div className="mt-4 p-3 rounded-lg bg-ticca-orange/5 border border-ticca-orange/10 text-center">
                {htmlString[386] ? (
                  parser(htmlString[386])
                ) : (
                  <div className="w-full  flex  m-auto justify-center">
                    {" "}
                    <ShimmerLoaderOneLine />{" "}
                  </div>
                )}
              </div>
            </FadeIn>
          </div>
        </section>
        <section id="traction" className="py-16 relative">
          <div className="container">
            <FadeIn>
              <SectionLabel label="Traction" color="red" />
              {htmlString[387] ? (
                parser(htmlString[387])
              ) : (
                <div className="m-auto mt-[20px] mb-[10px] ">
                  <ShimmerLoaderOneLine />
                </div>
              )}
            </FadeIn>

            <StaggerContainer className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
              {stats.map((stat, i) => (
                <StaggerItem key={i}>
                  <motion.div
                    whileHover={{ y: -3, scale: 1.02 }}
                    className="p-4 rounded-xl bg-secondary/40 border border-border/50 text-center"
                  >
                    <div className="flex justify-center mb-2">{stat.icon}</div>
                    <motion.div
                      initial={{ opacity: 0, scale: 0.8 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.4, delay: i * 0.08 }}
                      className="font-display font-bold text-2xl text-foreground"
                    >
                      {htmlString[388] ? stat.value : <ShimmerLoaderOneLine />}
                    </motion.div>
                    <div className="text-sm font-semibold text-foreground">
                      {htmlString[388] ? stat.label : <ShimmerLoaderOneLine />}
                    </div>
                    <div className="text-xs text-foreground/60">
                      {htmlString[388] ? stat.sub : <ShimmerLoaderOneLine />}
                    </div>
                  </motion.div>
                </StaggerItem>
              ))}
            </StaggerContainer>

            <FadeIn delay={0.15}>
              <div className="p-5 rounded-xl bg-secondary/30 border border-border/50">
                {htmlString[388] ? (
                  parser(htmlString[388])
                ) : (
                  <ShimmerLoaderOneLine />
                )}
                <div className="grid sm:grid-cols-3 gap-3">
                  {[
                    { value: "80+", label: "Contractor accounts" },
                    { value: "120+", label: "Projects over 10 years" },
                    { value: "Extensive", label: "Activity logs & evidence" },
                  ].map((item, i) => (
                    <div
                      key={item.label}
                      className="flex items-center gap-3 p-3 rounded-lg bg-background/60 border border-border/30"
                    >
                      {htmlString[389] ? (
                        parser(htmlString[389 + i])
                      ) : (
                        <ShimmerLoaderOneLine />
                      )}
                    </div>
                  ))}
                </div>
                {htmlString[392] ? (
                  parser(htmlString[392])
                ) : (
                  <div className="w-full mt-3 m-auto">
                    <ShimmerLoaderOneLine />
                  </div>
                )}
              </div>
            </FadeIn>
          </div>
        </section>
        <section id="strategy" className="py-16 relative">
          <div className="absolute inset-0 bg-dot-pattern opacity-15" />
          <div className="container relative">
            <FadeIn>
              <SectionLabel label="Go-To-Market & Growth" color="blue" />
              {htmlString[393] ? (
                parser(htmlString[393])
              ) : (
                <div className="w-full mt-[10px] mb-[10px]">
                  {" "}
                  <ShimmerLoaderwhite />{" "}
                </div>
              )}
            </FadeIn>

            {/* GTM Phases */}
            <div className="relative mb-6">
              <div className="hidden md:block absolute top-7 left-0 right-0 h-[2px] bg-border/50 z-0" />
              <StaggerContainer className="grid md:grid-cols-3 gap-4 relative z-10">
                {[
                  {
                    phase: "Phase 1",
                    title: `${htmlString[394]}`,
                    icon: <Crosshair className="w-4 h-4 text-ticca-red" />,
                    color: "border-t-ticca-red",
                    dot: "bg-ticca-red",
                    items: [
                      `${htmlString[395]}`,
                      `${htmlString[396]}`,
                      `${htmlString[397]}`,
                    ],
                  },
                  {
                    phase: "Phase 2",
                    title: `${htmlString[398]}`,
                    icon: <Zap className="w-4 h-4 text-ticca-orange" />,
                    color: "border-t-ticca-orange",
                    dot: "bg-ticca-orange",
                    items: [`${htmlString[399]}`, `${htmlString[400]}`],
                  },
                  {
                    phase: "Phase 3",
                    title: `${htmlString[401]}`,
                    icon: <Target className="w-4 h-4 text-ticca-blue" />,
                    color: "border-t-ticca-blue",
                    dot: "bg-ticca-blue",
                    items: [
                      `${htmlString[402]}`,
                      `${htmlString[403]}`,
                      `${htmlString[404]}`,
                    ],
                  },
                ].map((phase, i) => (
                  <StaggerItem key={i}>
                    <motion.div
                      whileHover={{ y: -3 }}
                      className={`p-4 rounded-xl bg-secondary/30 border border-border/50 border-t-[3px] ${phase.color} h-full`}
                    >
                      <div className="flex items-center gap-2 mb-2">
                        <div
                          className={`w-3.5 h-3.5 rounded-full ${phase.dot} shadow-sm`}
                        />
                        {phase.icon}
                        <span className="text-xs font-bold uppercase tracking-wider text-muted-foreground">
                          {phase.phase}
                        </span>
                      </div>
                      {phase.title == "undefined" ? (
                        <ShimmerLoaderOneLine />
                      ) : (
                        parser(phase.title)
                      )}
                      <div className="space-y-1.5">
                        {phase.items.map((item, j) => (
                          <div
                            key={j}
                            className="flex items-start gap-2 text-sm text-muted-foreground"
                          >
                            <ArrowRight className="w-3.5 h-3.5 mt-0.5 shrink-0 text-muted-foreground/50" />
                            {item == "undefined" ? (
                              <ShimmerLoaderOneLine />
                            ) : (
                              parser(item)
                            )}
                          </div>
                        ))}
                      </div>
                    </motion.div>
                  </StaggerItem>
                ))}
              </StaggerContainer>
            </div>

            {/* Growth Strategy */}
            <FadeIn delay={0.2}>
              <div className="p-5 rounded-xl bg-secondary/40 border border-border/50">
                {htmlString[405] ? (
                  parser(htmlString[405])
                ) : (
                  <div className="w-full mt-[10px] mb-[10px]">
                    {" "}
                    <ShimmerLoaderOneLine />{" "}
                  </div>
                )}
                <div className="grid md:grid-cols-3 gap-3">
                  {[
                    {
                      icon: <Globe className="w-4 h-4 text-ticca-green" />,
                      trend: "Distributed Work",
                      driver: "Demand for verifiable work systems",
                    },
                    {
                      icon: <Building className="w-4 h-4 text-ticca-blue" />,
                      trend: "AI Integration",
                      driver: "Rising operational complexity",
                    },
                    {
                      icon: (
                        <TrendingUp className="w-4 h-4 text-ticca-orange" />
                      ),
                      trend: "SaaS Consolidation",
                      driver: "Need for unified intelligent platforms",
                    },
                  ].map((item, i) => (
                    <motion.div
                      key={i}
                      whileHover={{ scale: 1.02 }}
                      className="flex items-start gap-3 p-3 rounded-lg bg-background/50 border border-border/30"
                    >
                      <div className="w-8 h-8 rounded-lg bg-background flex items-center justify-center shadow-card shrink-0">
                        {item.icon}
                      </div>
                      <div>
                        {typeof htmlString[406 + i] !== "string" ? (
                          <ShimmerLoaderOneLine />
                        ) : (
                          parser(htmlString[406 + i])
                        )}
                      </div>
                    </motion.div>
                  ))}
                </div>
                <div className="mt-3 p-3 rounded-lg bg-ticca-blue/5 border border-ticca-blue/10">
                  {htmlString[409] ? (
                    parser(htmlString[409])
                  ) : (
                    <ShimmerLoaderOneLine />
                  )}
                </div>
              </div>
            </FadeIn>
          </div>
        </section>
        <section id="founder" className="py-14 relative">
          <div className="container">
            <FadeIn>
              <SectionLabel label="Founder" color="blue" />
              {htmlString[410] ? (
                parser(htmlString[410])
              ) : (
                <div className="w-full mt-[10px] mb-[10px]">
                  {" "}
                  <ShimmerLoaderwhite />{" "}
                </div>
              )}
            </FadeIn>

            <div className="grid md:grid-cols-[1fr,1fr] gap-5">
              <FadeIn delay={0.05}>
                <div className="p-5 rounded-xl bg-secondary/40 border border-border/50 h-full">
                  {htmlString[411] ? (
                    parser(htmlString[411])
                  ) : (
                    <div className="w-full mt-[10px] mb-[10px]">
                      {" "}
                      <ShimmerLoaderwhite />{" "}
                    </div>
                  )}
                  <h3 className="font-display font-bold text-base mb-3 text-foreground">
                    Highlights
                  </h3>
                  <div className="relative pl-5">
                    <div className="absolute left-[7px] top-1 bottom-1 w-[2px] bg-border" />
                    {milestones.map((m, i) => (
                      <motion.div
                        key={i}
                        initial={{ opacity: 0, x: -10 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: i * 0.08 }}
                        className="relative flex items-start gap-3 mb-3 last:mb-0"
                      >
                        <div className="absolute -left-5 top-0.5 w-4 h-4 rounded-full bg-background border-2 border-ticca-blue flex items-center justify-center">
                          <div className="w-1.5 h-1.5 rounded-full bg-ticca-blue" />
                        </div>
                        {m.year == "undefined" ? (
                          <ShimmerLoaderwhite />
                        ) : (
                          <div className="flex items-start gap-2">
                            <span className="text-sm font-bold text-ticca-blue min-w-[65px] shrink-0">
                              {parser(m.year)}
                            </span>
                            <span className="text-muted-foreground shrink-0">
                              {m.icon}
                            </span>
                            <span className="text-sm text-muted-foreground">
                              {parser(m.label)}
                            </span>
                          </div>
                        )}
                      </motion.div>
                    ))}
                  </div>
                </div>
              </FadeIn>

              <FadeIn delay={0.1}>
                <div className="p-5 rounded-xl bg-ticca-blue/[0.03] border border-ticca-blue/15 h-full flex flex-col justify-center">
                  <div className="flex items-center gap-2 mb-2">
                    <Plane className="w-5 h-5 text-ticca-blue" />
                    {htmlString[420] ? (
                      parser(htmlString[420])
                    ) : (
                      <ShimmerLoaderOneLine />
                    )}
                  </div>
                  {htmlString[421] ? (
                    parser(htmlString[421])
                  ) : (
                    <ShimmerLoaderOneLine />
                  )}
                  <div className="p-3 rounded-lg bg-ticca-blue/5 border border-ticca-blue/10">
                    <p className="text-sm font-semibold text-foreground">
                      CES Innovations Award 2017 - Proof of innovation
                    </p>
                  </div>
                </div>
              </FadeIn>
            </div>
          </div>
        </section>
        <section className="py-16 relative">
          <div className="absolute inset-0">
            <div className="absolute bottom-1/4 left-0 w-[250px] h-[250px] bg-ticca-orange/3 rounded-full blur-[80px]" />
          </div>
          <div className="container relative">
            <FadeIn>
              <SectionLabel label="Founder-Market Fit" color="orange" />
              {htmlString[422] ? (
                parser(htmlString[422])
              ) : (
                <div className="w-full mt-[10px] mb-[10px]">
                  {" "}
                  <ShimmerLoaderwhite />{" "}
                </div>
              )}
            </FadeIn>

            <div className="grid md:grid-cols-2 gap-5">
              {/* Founder experience */}
              <FadeIn delay={0.05}>
                <div className="p-6 rounded-2xl bg-secondary/30 border border-border/50 h-full">
                  <div className="flex items-center gap-2 mb-4">
                    <UserCheck className="w-5 h-5 text-ticca-orange" />
                    {htmlString[423] ? (
                      parser(htmlString[423])
                    ) : (
                      <ShimmerLoaderOneLine />
                    )}
                  </div>
                  {htmlString[424] ? (
                    parser(htmlString[424])
                  ) : (
                    <div className="w-full mt-[10px] mb-[10px]">
                      {" "}
                      <ShimmerLoaderwhite />{" "}
                    </div>
                  )}
                  <div className="space-y-3 mb-4">
                    {experiences.map((exp, i) => (
                      <motion.div
                        key={`${exp.text}-${i}-28628ye`}
                        whileHover={{ x: 4 }}
                        className="flex items-center gap-3 p-3 rounded-xl bg-background border border-border/40"
                      >
                        <span className={exp.color}>{exp.icon}</span>
                        {exp.text == "undefined" ? (
                          <ShimmerLoaderOneLine />
                        ) : (
                          <span className="text-sm font-medium text-foreground">
                            {parser(exp.text)}
                          </span>
                        )}
                      </motion.div>
                    ))}
                  </div>
                  <div className="p-3 rounded-lg bg-ticca-orange/5 border border-ticca-orange/10">
                    {htmlString[428] ? (
                      parser(htmlString[428])
                    ) : (
                      <div className="w-full mt-[10px] mb-[10px]">
                        {" "}
                        <ShimmerLoaderOneLine />{" "}
                      </div>
                    )}
                  </div>
                </div>
              </FadeIn>

              {/* Expansion path */}
              <FadeIn delay={0.1}>
                <div className="p-6 rounded-2xl bg-ticca-blue/[0.03] border border-ticca-blue/15 h-full flex flex-col">
                  <div className="flex items-center gap-2 mb-4">
                    <ArrowRight className="w-5 h-5 text-ticca-blue" />
                    {htmlString[428] ? (
                      parser(htmlString[429])
                    ) : (
                      <ShimmerLoaderOneLine />
                    )}
                  </div>
                  {htmlString[429] ? (
                    parser(htmlString[430])
                  ) : (
                    <div className="w-full mt-[10px] mb-[10px]">
                      {" "}
                      <ShimmerLoaderOneLine />{" "}
                    </div>
                  )}

                  <StaggerContainer className="space-y-3 flex-1">
                    {expansions.map((item, j) => (
                      <StaggerItem key={`${item.label}-${j}`}>
                        <motion.div
                          whileHover={{ y: -2, scale: 1.02 }}
                          className={`flex items-center gap-3 p-4 rounded-xl border ${item.color}`}
                        >
                          {item.icon}
                          {htmlString[431 + j] ? (
                            <span className="text-sm font-bold">
                              {parser(htmlString[431 + j])}
                            </span>
                          ) : (
                            <ShimmerLoaderOneLine />
                          )}
                        </motion.div>
                      </StaggerItem>
                    ))}
                  </StaggerContainer>
                </div>
              </FadeIn>
            </div>
          </div>
        </section>
        <section className="py-16 relative overflow-hidden">
          <div className="absolute inset-0">
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[500px] h-[250px] bg-ticca-blue/5 rounded-full blur-[100px]" />
          </div>
          <div className="container relative text-center max-w-3xl">
            <FadeIn>
              <motion.h5
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="font-display font-bold text-2xl md:text-4xl mb-3 leading-tight"
              >
                {htmlString[426] ? (
                  parser(htmlString[434])
                ) : (
                  <div className="w-full mt-[10px] mb-[10px]  flex justify-center">
                    <ShimmerLoaderOneLine />
                  </div>
                )}

                <span className="block mt-1 whitespace-nowrap">
                  {htmlString[427] ? (
                    parser(htmlString[435])
                  ) : (
                    <div className="w-full mt-[10px] mb-[10px]  flex justify-center">
                      <ShimmerLoaderOneLine />
                    </div>
                  )}
                </span>
              </motion.h5>
            </FadeIn>

            <FadeIn delay={0.1}>
              <motion.div
                whileHover={{ scale: 1.02 }}
                className="inline-flex items-center gap-3 p-5 rounded-xl bg-secondary/50 border border-border/50 mb-8"
              >
                <img
                  src="https://public.ticca.com/images/logo/Logo_Company.svg"
                  alt="TICCA"
                  className="h-6"
                />
                <div className="text-left">
                  {htmlString[428] ? (
                    parser(htmlString[436])
                  ) : (
                    <ShimmerLoaderOneLine />
                  )}
                </div>
              </motion.div>
            </FadeIn>

            <FadeIn delay={0.2}>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <motion.button
                  onClick={() => setDemoOpen(true)}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.97 }}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-ticca-blue text-white font-semibold text-sm shadow-brand transition-colors hover:bg-ticca-blue/90"
                >
                  <Calendar className="w-4 h-4" />
                  Request a Demo
                </motion.button>
                <motion.button
                  onClick={() => {
                    navigator(PageRoutes.question);
                  }}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.97 }}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-background border-2 border-ticca-blue/30 text-ticca-blue font-semibold text-sm hover:bg-ticca-blue/5 transition-colors"
                >
                  <MessageCircle className="w-4 h-4" />
                  Talk to our CEO
                </motion.button>
              </div>
            </FadeIn>
          </div>

          <DemoRequestModal
            open={demoOpen}
            onClose={() => setDemoOpen(false)}
          />
        </section>
      </div>
    </>
  );
};

export default ExecutiveSummary;
